<template>
  <div>
    <modal centered :show.sync="localOpen" id="addAudiance" bodyClasses="create-campaign-modal-body"
      footerClasses="border-top p-2">
      <div slot="header"><span class="p-3 d-block"></span></div>
     <div class="pb-3 w-100 d-flex align-items-center justify-content-between col-sm-12 col-md-12 col-lg-12 row">
        <h3 class="title title-up m-0" style="color: #222a42 !important;">
          Media Storage
        </h3>
        <div class="d-flex flex-column">
          <div class="d-flex align-items-center align-self-end" style="gap: 8px; margin-right: 10px;">
             <el-upload ref="upload" class="audiance-upload" accept="image/jpeg,image/png,image/gif,application/zip,video/mp4,video/quicktime,video/x-msvideo,video/mpeg" :auto-upload="false"
            :show-file-list="false" :on-change="handleChange" action="">
            <el-button type="primary" icon="el-icon-upload2" :disabled="isDeletingMedia">Upload Media</el-button>
          </el-upload>
          <el-dropdown trigger="click">
            <span class="menu-drop-anchor">
              <el-button icon="el-icon-more"></el-button>
            </span>
            <el-dropdown-menu slot="dropdown">
              <div @click.stop="" class="d-flex align-items-center text-dark px-3" style="gap: 12px; font-size: 14px;">
                <span><i class="fa-regular fa-cloud" style="margin-right: 4px;"></i>Storage Used</span>
                <span>{{ mediaStorage }}</span>
              </div>
            </el-dropdown-menu>
          </el-dropdown>
           </div>
           <div class="text-muted" style="font-size: 12px; margin-top: 6px;">
             <span v-if="campaignMediaType === 'video'">
               Supported: MP4, MOV, MPEG (video)
             </span>
             <span v-else>
               Supported: JPG, PNG, GIF (images), ZIP (HTML5)
             </span>
           </div>
        </div>
      </div>

      <div class="col-sm-12 col-md-12 col-lg-12 d-flex row align-items-end mt-4">
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <label>{{ CompanyNamedisabled ? "Client" : "Select Client" }}</label>
          <el-select class="select__form__client w-100" size="large" placeholder="Select Client Name"
            v-model="selectedCompany" :disabled="CompanyNamedisabled" @change="onCompanyChange">
            <el-option v-for="option in companyList" :value="option.id" :label="(option.company_name == null || option.company_name === false) ? '' : String(option.company_name)" :key="option.id">
            </el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-4 mb-3 mb-md-0">
          <label class="d-none d-md-block">Search by Name</label>
          <el-input size="large" placeholder="Search media name..." prefix-icon="el-icon-search" v-model="searchQuery" clearable />
        </div>
        <div class="col-12 col-md-2 mb-3 mb-md-0" v-if="campaignMediaType !== 'video'">
          <label class="d-none d-md-block">File Type</label>
          <el-select v-model="activeFileTypeFilter" size="large" placeholder="All types" class="w-100" filterable>
            <el-option label="All Types" value="all"></el-option>
            <el-option label="Images" value="image"></el-option>
            <el-option label="HTML5" value="html5"></el-option>
          </el-select>
        </div>
        <div class="col-12 col-md-2 mb-3 mb-md-0" v-if="campaignMediaType !== 'video'">
          <label class="d-none d-md-block">Size</label>
          
          <div class="d-flex align-items-center"> <el-select v-model="localActiveDimensionFilter" size="large" placeholder="All sizes" class="w-100" filterable>
              
              <el-option label="All" value="all"></el-option>
              <el-option label="Available Only" value="available"></el-option>
              
              <el-option-group label="Specific Sizes">
                  <el-option
                    v-for="dim in allowedDims"
                    :key="`${dim.w}x${dim.h}`"
                    :label="`${dim.w} x ${dim.h}`"
                    :value="`${dim.w}x${dim.h}`"
                  />
              </el-option-group>

            </el-select>
            </div>
        </div>      
      </div>      
      
      <!-- Minimum Recommended Sizes Section (Display only, show for Images or All Types) -->
      <div v-if="campaignMediaType !== 'video' && (activeFileTypeFilter === 'all' || activeFileTypeFilter === 'image')" class="col-sm-12 col-md-12 col-lg-12 mt-4 mb-3">
        <div class="recommended-sizes-section">
          <div class="recommended-sizes-header">
            <i class="el-icon-star-on" style="color: #409EFF; margin-right: 8px;"></i>
            <span class="recommended-sizes-title">Minimum Recommended Sizes</span>
          </div>
          <div class="recommended-sizes-description">
            <span>For optimal display performance and compatibility across all advertising platforms</span>
          </div>
          <div class="recommended-sizes-grid">
            <span class="size-badge">300×250</span>
            <span class="size-badge">728×90</span>
            <span class="size-badge">160×600</span>
            <span class="size-badge">300×600</span>
            <span class="size-badge">320×50</span>
            <span class="size-badge">300×50</span>
            <span class="size-badge">970×250</span>
            <span class="size-badge">250×250</span>
            <span class="size-badge">200×200</span>
          </div>
        </div>
      </div>
      
      <!-- HTML5 Ads Specification Section (Display only, show for HTML5 or All Types) -->
      <div v-if="campaignMediaType !== 'video' && (activeFileTypeFilter === 'all' || activeFileTypeFilter === 'html5')" class="col-sm-12 col-md-12 col-lg-12 mt-3 mb-3">
        <div class="html5-spec-container">
          <!-- Header with Collapse Toggle -->
          <div class="html5-spec-header" @click="html5SpecExpanded = !html5SpecExpanded">
            <div class="html5-spec-header-left">
              <i class="el-icon-folder-opened" style="color: #409EFF; font-size: 18px; margin-right: 10px;"></i>
              <div>
                <span class="html5-spec-title">HTML5 Ads Requirements</span>
                <span class="html5-spec-subtitle">Simpli.fi Specifications</span>
              </div>
            </div>
            <div class="html5-spec-header-right">
              <el-button 
                type="primary" 
                size="small" 
                icon="el-icon-download" 
                @click.stop="downloadHtml5Example"
                style="margin-right: 8px;">
                Download Example
              </el-button>
              <a href="https://github.com/simplifi/html5" target="_blank" rel="noopener noreferrer" 
                 class="html5-spec-link" @click.stop>
                <i class="el-icon-link" style="margin-right: 4px;"></i>
                View Simpli.fi Docs
              </a>
              <i :class="html5SpecExpanded ? 'el-icon-arrow-up' : 'el-icon-arrow-down'" 
                 class="html5-spec-toggle-icon"></i>
            </div>
          </div>

          <!-- Expandable Content -->
          <div v-show="html5SpecExpanded" class="html5-spec-content">
            <!-- Quick Checklist -->
            <div class="html5-quick-checklist">
              <div class="html5-checklist-item">
                <i class="el-icon-check" style="color: #67C23A;"></i>
                <span>ZIP format with <code>index.html</code></span>
              </div>
              <div class="html5-checklist-item">
                <i class="el-icon-check" style="color: #67C23A;"></i>
                <span>ZIP size: <strong>≤ 250 KB</strong></span>
              </div>
              <div class="html5-checklist-item">
                <i class="el-icon-check" style="color: #67C23A;"></i>
                <span>Render size: <strong>≤ 2.1 MB</strong></span>
              </div>
              <div class="html5-checklist-item">
                <i class="el-icon-check" style="color: #67C23A;"></i>
                <span>Use <code>{{clickMacro}}</code> for click URL</span>
              </div>
            </div>

            <!-- Requirements Cards -->
            <div class="html5-requirements-grid">
              <!-- File Structure Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #e3f2fd 0%, #bbdefb 100%);">
                  <i class="el-icon-folder" style="color: #1976d2; font-size: 24px;"></i>
                  <span class="html5-card-title">File Structure</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-requirement-item">
                    <i class="el-icon-document" style="color: #1976d2;"></i>
                    <div>
                      <strong>ZIP Archive</strong>
                      <p>Package all files in a single ZIP file. Only actual files should be added (not the containing folder).</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-star-on" style="color: #ff9800;"></i>
                    <div>
                      <strong>Entry Point: <code>index.html</code></strong>
                      <p>Must include a single file named <code>index.html</code> as the main file</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-warning" style="color: #f44336;"></i>
                    <div>
                      <strong>ZIP Size Limit: 250 KB</strong>
                      <p>ZIP file must be 250 KB or smaller</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-files" style="color: #1976d2;"></i>
                    <div>
                      <strong>File Count: Up to 50 files</strong>
                      <p>ZIP file may contain up to 50 files</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-close" style="color: #f44336;"></i>
                    <div>
                      <strong>No Subfolders</strong>
                      <p>Subfolders are not allowed. All files must be in the root of the ZIP</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-picture" style="color: #1976d2;"></i>
                    <div>
                      <strong>Allowed File Types</strong>
                      <p><code>.css</code>, <code>.js</code>, <code>.html</code>, <code>.gif</code>, <code>.png</code>, <code>.jpg</code>, <code>.jpeg</code>, <code>.svg</code></p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- HTML Structure Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #fff3e0 0%, #ffe0b2 100%);">
                  <i class="el-icon-document" style="color: #f57c00; font-size: 24px;"></i>
                  <span class="html5-card-title">HTML Structure</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-requirement-item">
                    <i class="el-icon-check" style="color: #67C23A;"></i>
                    <div>
                      <strong>Required Tags</strong>
                      <p><code>index.html</code> must include: <code>&lt;!DOCTYPE html&gt;</code>, <code>&lt;html&gt;</code>, <code>&lt;head&gt;</code>, <code>&lt;body&gt;</code></p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-info" style="color: #409EFF;"></i>
                    <div>
                      <strong>Ad Size Meta Tag (Optional)</strong>
                      <p>Include <code>&lt;meta name="ad.size" content="width=300,height=250"&gt;</code> in <code>&lt;head&gt;</code> for automatic size detection</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-warning" style="color: #f44336;"></i>
                    <div>
                      <strong>Render Size Limit: 2.1 MB</strong>
                      <p>Total HTML5 ad render size must not exceed 2.1 MB</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-info" style="color: #409EFF;"></i>
                    <div>
                      <strong>Macro Replacement</strong>
                      <p>Macro replacement is only performed on <code>index.html</code>. Macros in JavaScript files are not supported.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- External References Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);">
                  <i class="el-icon-connection" style="color: #7b1fa2; font-size: 24px;"></i>
                  <span class="html5-card-title">External References</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-requirement-item">
                    <i class="el-icon-warning" style="color: #f44336;"></i>
                    <div>
                      <strong>Maximum: 10 External References</strong>
                      <p>External references are allowed, but must not exceed 10</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-info" style="color: #409EFF;"></i>
                    <div>
                      <strong>Size Impact</strong>
                      <p>External references count against your overall render size limit (2.1 MB)</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-check" style="color: #67C23A;"></i>
                    <div>
                      <strong>Exempt Domains</strong>
                      <p>The following domains are exempt from size limits:<br>
                      <code>s0.2mdn.net/ads/</code>, <code>ajax.googleapis.com</code>,<br>
                      <code>fonts.googleapis.com</code>, <code>fonts.gstatic.com</code>,<br>
                      <code>tpc.googlesyndication.com</code></p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Media Requirements Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);">
                  <i class="el-icon-video-camera" style="color: #388e3c; font-size: 24px;"></i>
                  <span class="html5-card-title">Video & Audio</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-requirement-item">
                    <i class="el-icon-warning" style="color: #f44336;"></i>
                    <div>
                      <strong>External Hosting Required</strong>
                      <p>If you use <code>&lt;video&gt;</code> or <code>&lt;audio&gt;</code> tags, you must host the external asset</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-close" style="color: #f44336;"></i>
                    <div>
                      <strong>No Auto-Play Audio</strong>
                      <p>Videos that play by default <strong>must not</strong> play audio by default. Audio <strong>must not</strong> play by default.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Additional Information Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #e8f5e9 0%, #c8e6c9 100%);">
                  <i class="el-icon-info" style="color: #388e3c; font-size: 24px;"></i>
                  <span class="html5-card-title">Additional Information</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-requirement-item">
                    <i class="el-icon-close" style="color: #f44336;"></i>
                    <div>
                      <strong>Expandable Ads Not Supported</strong>
                      <p>Expandable ads are not supported by Simpli.fi</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-warning" style="color: #ff9800;"></i>
                    <div>
                      <strong>Google Web Designer</strong>
                      <p>When creating ads with Google Web Designer, select <strong>"Non-Google Ad"</strong> from the Environment dropdown. DoubleClick, AdMob and AdWords environment ads are not supported.</p>
                    </div>
                  </div>
                  <div class="html5-requirement-item">
                    <i class="el-icon-success" style="color: #67C23A;"></i>
                    <div>
                      <strong>Click Verification</strong>
                      <p>Uploaded ads are automatically click-verified. If verification fails, hover over the click-verify button to view error messages. Try adding the <code>clickthru</code> class to the element that opens the target URL.</p>
                    </div>
                  </div>
                </div>
              </div>

              <!-- Click Tracking Card -->
              <div class="html5-requirement-card">
                <div class="html5-card-header" style="background: linear-gradient(135deg, #f3e5f5 0%, #e1bee7 100%);">
                  <i class="el-icon-link" style="color: #7b1fa2; font-size: 24px;"></i>
                  <span class="html5-card-title">Click Tracking</span>
                </div>
                <div class="html5-card-body">
                  <div class="html5-code-example">
                    <div class="html5-code-header">
                      <span>Use this placeholder in your HTML:</span>
                    </div>
                    <div class="html5-code-block">
                      <code>&lt;a href="{{clickMacro}}"&gt;Click Here&lt;/a&gt;</code>
                    </div>
                    <div class="html5-code-note">
                      <i class="el-icon-info" style="margin-right: 6px;"></i>
                      This will be automatically replaced with the destination URL
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
      
      <!-- Video Requirements Section (Video campaign only) -->
      <div v-if="campaignMediaType === 'video'" class="col-sm-12 col-md-12 col-lg-12 mt-4 mb-3">
        <div class="recommended-sizes-section">
          <div class="recommended-sizes-header">
            <i class="el-icon-video-camera" style="color: #409EFF; margin-right: 8px;"></i>
            <span class="recommended-sizes-title">Video Requirements</span>
          </div>
          <div class="recommended-sizes-description">
            <span>Video dimensions are flexible, but must meet minimum requirements</span>
          </div>
          <div class="recommended-sizes-grid">
            <span class="size-badge" style="background: #f0f9ff; border-color: #409EFF; color: #409EFF; font-weight: 600;">
              Minimum: 768×576
            </span>
            <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
              Preferred: 1920×1080
            </span>
            <span class="size-badge" style="background: #f0f9ff; border-color: #67C23A; color: #67C23A; font-weight: 600;">
              Preferred: 1920×1200
            </span>
            <span class="size-badge" style="background: #f0f9ff; border-color: #909399; color: #909399;">
              Aspect Ratio: 16:9
            </span>
          </div>
        </div>
      </div>
      
      <div class="col-sm-12 col-md-12 col-lg-12 mt-4">
        <div class="d-flex align-items-center justify-content-between mb-2" style="height: 41px;">
          <span class="font-weight-600 text-dark" style="font-size: 14px;">Files</span>
          <div v-if="selectedItems.length">
            <el-button round @click="selectedItems = []" icon="el-icon-close" :disabled="isDeletingMedia">{{ selectedItems.length }} Selected</el-button>
            <el-button type="text" icon="el-icon-download" style="color: #000000; font-size: 16px;" @click="downloadSelected" />
            <el-button type="text" icon="el-icon-delete" style="color: #000000; font-size: 16px;" :disabled="isDeletingMedia" @click="handleDelete" />
          </div>
        </div>
        
      <div class="media-collection-wrapper">
        
        <div v-if="isLoadingMedia" class="state-container">
          <i class="el-icon-loading"></i>
          <span>Loading media...</span>
        </div>
        
        <div v-else-if="isLoadingMediaError" class="state-container">
          <i class="el-icon-warning-outline" style="color: #F56C6C;"></i>
          <span>Failed to load media. Please try again.</span>
        </div>

        <div v-else-if="!displayedGroups.length" class="state-container">
          <i class="el-icon-zoom-out"></i>
          <span>No media found matching your filters.</span>
        </div>

        <!-- Display campaign: Group by dimensions -->
        <div v-else-if="campaignMediaType !== 'video'">
          <div 
            v-for="group in displayedGroups" 
            :key="group.dimensionKey" 
            class="media-dimension-group"
          >
            <div class="dimension-title">
              <div class="dimension-divider"></div>
              <div class="dimension-row">
                <span class="dimension-label">{{ group.w }} x {{ group.h }}</span>
                <span class="dimension-count">({{ group.media.length }} items)</span>
              </div>
            </div>
            <div class="media-collection-grid">
              <media-item 
                v-for="item in group.media"
                :key="item.id"
                :item="item"
                :selectedItems="selectedItems"
                :isDeleting="deletingIds.includes(item.id)"
                @select="selectItem(item)"
                @preview="openPreview(item)"
              />
              <div class="media-box placeholder" :class="{ 'placeholder--disabled': isDeletingMedia }" @click="openUpload(group)">
                <i class="el-icon-plus"></i>
                <span class="placeholder-label">Add {{ group.w }}x{{ group.h }}</span>
              </div>
            </div>
          </div>
        </div>
        
        <!-- Video campaign: Single list without dimension grouping -->
        <div v-else>
          <div class="media-collection-grid">
            <media-item 
              v-for="item in displayedGroups"
              :key="item.id"
              :item="item"
              :selectedItems="selectedItems"
              :isDeleting="deletingIds.includes(item.id)"
              @select="selectItem(item)"
              @preview="openPreview(item)"
            />
            <div class="media-box placeholder" :class="{ 'placeholder--disabled': isDeletingMedia }" @click="openUploadVideo">
              <i class="el-icon-plus"></i>
              <span class="placeholder-label">Add Video</span>
            </div>
          </div>
        </div>        
      </div>     
      </div>

      <template slot="footer">
        <div class="align-items-center col-lg-12 col-md-12 col-sm-12 d-flex justify-content-between" style="gap:8px">
          <div style="font-size: 14px;">
            <span v-if="campaignMediaType === 'video'">
              <strong>Note: </strong>Video campaigns support: MP4, MOV, MPEG formats
            </span>
            <span v-else>
              <strong>Note: </strong>Display campaigns support: JPG, PNG, GIF (images) and ZIP (HTML5) formats
            </span>
          </div>
          <div class="d-flex flex-row-reverse flex-wrap align-items-center" style="gap:8px">
            <base-button
              v-if="selectedItems.length"
              size="sm"
              style="height:40px"
              :disabled="isDeletingMedia || isLoadingMedia"
              @click="addToCampaign"
            >
              <span v-if="isDeletingMedia">Deleting...</span>
              <span v-else>Add Media</span>
            </base-button>
            <base-button @click="localOpen = false" simple size="sm" style="height:40px">Cancel</base-button>
          </div>
            <!-- Media Preview Dialog -->
            <el-dialog
              :visible.sync="previewOpen"
              :append-to-body="true"
              width="70%"
              custom-class="media-preview-dialog"
              :show-close="true"
              @close="handlePreviewDialogClose"
            >
              <div v-if="previewItem" class="preview-body d-flex justify-content-center align-items-center" style="min-height: 400px;">
                <!-- Image Preview -->
                <div v-if="previewItemType === 'image'" class="w-100 d-flex justify-content-center">
                  <img :src="previewItem.media" :alt="previewItem.name" style="max-width:100%; max-height:70vh; border-radius:8px;" />
                </div>
                
                <!-- Video Preview -->
                <div v-else-if="previewItemType === 'video'" class="w-100 d-flex justify-content-center">
                  <video 
                    ref="previewVideo"
                    :src="previewItem.media" 
                    controls 
                    style="max-width:100%; max-height:70vh; border-radius:8px;"
                    preload="metadata"
                  >
                    Your browser does not support the video tag.
                  </video>
                </div>
                
                <!-- HTML5 Preview -->
                <div v-else-if="previewItemType === 'html5'" class="w-100 d-flex justify-content-center align-items-center" style="min-height: 500px;">
                  <div v-if="html5PreviewLoading" class="text-center">
                    <i class="el-icon-loading" style="font-size: 24px; color: #409EFF;"></i>
                    <p class="mt-2">Loading HTML5 preview...</p>
                  </div>
                  <div v-else-if="html5PreviewError" class="text-center text-danger">
                    <i class="el-icon-warning" style="font-size: 24px;"></i>
                    <p class="mt-2">{{ html5PreviewError }}</p>
                  </div>
                  <iframe 
                    v-else-if="html5PreviewBlobUrl"
                    ref="html5PreviewIframe"
                    :src="html5PreviewBlobUrl" 
                    frameborder="0"
                    style="width: 100%; min-height: 500px; border-radius: 8px; border: 1px solid #e4e7ed;"
                    sandbox="allow-scripts allow-same-origin allow-forms"
                    @load="disableHtml5PreviewClicks"
                  ></iframe>
                </div>
                
              </div>
              <span slot="title">{{ previewItem ? previewItem.name : 'Preview' }}</span>
            </el-dialog>
        </div>
      </template>
    </modal>
  </div>
</template>

<script>
import { Modal } from "src/components";
import {
  Select, Option, OptionGroup, Upload, Button, Checkbox, Dropdown,Dialog,
  DropdownMenu,
  DropdownItem,
  Notification,
  MessageBox
} from "element-ui";
import { required } from "vee-validate/dist/rules";
import MediaItem from "./MediaItem.vue";
import { selection } from "d3";
import axios from 'axios';
import Resumable from 'resumablejs';
import { mapActions } from "vuex/dist/vuex.common.js";
import { downloadMediaBackground } from '../../helpers/downloadFile';

export default {
  components: {
    Modal,
    [Option.name]: Option,
    [OptionGroup.name]: OptionGroup,
    [Select.name]: Select,
    [Upload.name]: Upload,
    [Button.name]: Button,
    [Checkbox.name]: Checkbox,
    [Dropdown.name]: Dropdown,
    [DropdownMenu.name]: DropdownMenu,
    [DropdownItem.name]: DropdownItem,
    [Dialog.name]: Dialog,
    MediaItem
  },
  data() {
    return {
      selectedCompany: "",
      fileList: [],
      selectedItems: [],
      searchQuery: "",
      localActiveDimensionFilter: 'all', // Local copy of activeDimensionFilter prop
      activeFileTypeFilter: 'all', // Filter for file type: 'all', 'image', 'html5' (will be set to 'image' for display campaigns)
      html5SpecExpanded: true, // HTML5 specification section expanded by default
      clickMacro: '{{clickMacro}}', // Placeholder for click tracking URL
      allowedDims: [{"w":728,"h":90},{"w":160,"h":600},{"w":120,"h":600},{"w":120,"h":160},{"w":120,"h":240},{"w":120,"h":60},{"w":120,"h":90},{"w":125,"h":125},{"w":160,"h":90},{"w":180,"h":150},{"w":180,"h":90},{"w":200,"h":90},{"w":234,"h":60},{"w":240,"h":400},{"w":300,"h":100},{"w":300,"h":850},{"w":336,"h":280},{"w":450,"h":50},{"w":468,"h":15},{"w":468,"h":60},{"w":468,"h":728},{"w":728,"h":15},{"w":88,"h":31},{"w":700,"h":500},{"w":120,"h":20},{"w":168,"h":28},{"w":216,"h":36},{"w":320,"h":480},{"w":480,"h":320},{"w":768,"h":1024},{"w":1024,"h":768},{"w":320,"h":250},{"w":970,"h":250},{"w":200,"h":200},{"w":250,"h":250},{"w":320,"h":50},{"w":980,"h":120},{"w":980,"h":240},{"w":1250,"h":300},{"w":1250,"h":600},{"w":320,"h":320},{"w":250,"h":360},{"w":250,"h":600},{"w":250,"h":800},{"w":468,"h":250},{"w":600,"h":315},{"w":1200,"h":628},{"w":970,"h":90},{"w":640,"h":100},{"w":300,"h":400},{"w":468,"h":400},{"w":1400,"h":400},{"w":1920,"h":1080},{"w":1080,"h":1920},{"w":1224,"h":340},{"w":1920,"h":576},{"w":3840,"h":1080},{"w":1280,"h":360},{"w":840,"h":400},{"w":300,"h":250},{"w":300,"h":600},{"w":300,"h":50},{"w":500,"h":500},{"w":640,"h":640},{"w":1024,"h":1024}],
      mediaData: [],
      storageUsedBytes: 0,
      storageLimitBytes: 500 * 1024 * 1024,
      deletingIds: [],
      deleteOperationInProgress: false,
      uploadTargetDim: null,
      previewOpen: false,
      previewItem: null,
      html5PreviewBlobUrl: null,
      html5PreviewLoading: false,
      html5PreviewError: null,
      html5PreviewBlobUrls: null, // Map to store all blob URLs for cleanup
      jsZipLoadingPromise: null, // Promise for loading JSZip
      isLoadingMedia: false,
      isLoadingMediaError: false,
      displayedGroups: [],
      // Upload queue management
      uploadQueue: [], // Array of upload objects { uploadId, file, notification, resumableInstance, status }
      maxConcurrentUploads: 2, // Maximum number of simultaneous uploads (1 = sequential uploads for safer storage usage)
      activeUploads: [], // Currently active uploads
    };
  },
  props: {
    value: {
      type: Boolean,
      required: true
    },
    CompanyNamedisabled: {
      type: Boolean,
      required: true
    },
    companySelected: {
      type: String,
      required: true
    },
    companyList: {
      type: Array,
      required: true
    },
    activeDimensionFilter:{
      type: String,
      default: 'all'
    },
    campaignMediaType: {
      type: String,
      default: 'display', // 'display' or 'video'
      validator: (value) => ['display', 'video'].includes(value)
    }
  },
  computed: {
    /**
     * Determine preview type based on previewItem's ad_file_type_id
     */
    previewItemType() {
      if (!this.previewItem) return 'image';
      
      const adFileTypeId = this.detectAdFileType(this.previewItem);
      
      if (adFileTypeId === 6) {
        return 'video';
      } else if (adFileTypeId === 9) {
        return 'html5';
      }
      
      // Default to image
      return 'image';
    },
    localOpen: {
      get() {
        this.selectedCompany = this.companySelected;
        this.selectedItems = [];
        return this.value;
      },
      set(val) {
        this.$emit("input", val);
      }
    },
    storageUsedMB() {
      return (this.storageUsedBytes / 1024 / 1024).toFixed(2); // bytes -> MB
    },
    storageLimitMB() {
      return (this.storageLimitBytes / 1024 / 1024).toFixed(0);
    },
    mediaStorage() {
      return `${this.storageUsedMB}MB/${this.storageLimitMB}MB`;
    },
    isDeletingMedia() {
      return this.deleteOperationInProgress || this.deletingIds.length > 0;
    },
  },
  watch: {
    previewOpen(newVal) {
      // Cleanup HTML5 preview when dialog closes
      if (!newVal) {
        this.cleanupHtml5Preview();
        
        // Pause video when modal closes
        this.$nextTick(() => {
          if (this.$refs.previewVideo) {
            const video = this.$refs.previewVideo;
            if (video && typeof video.pause === 'function') {
              video.pause();
              // Reset video to beginning
              video.currentTime = 0;
            }
          }
        });
      }
    },
    searchQuery() {
      this.updateFilteredGroups();
    },
    localActiveDimensionFilter() {
      this.updateFilteredGroups();
    },
    activeDimensionFilter(newVal) {
      // Sync prop changes to local property
      this.localActiveDimensionFilter = newVal;
    },
    activeFileTypeFilter() {
      this.updateFilteredGroups();
    },
    campaignMediaType(newType) {
      // Re-filter when campaign type changes
      // Update file type filter: 'image' for display, 'all' for video
      if (newType !== 'video') {
        this.activeFileTypeFilter = 'image';
      } else {
        this.activeFileTypeFilter = 'all';
      }
      this.updateFilteredGroups();
    },
    async value(newValue) {
      if (newValue) {
        // Reset filter setiap kali modal dibuka
        this.isLoadingMedia = true;
        this.localActiveDimensionFilter = this.$props.activeDimensionFilter || 'all';
        // Set file type filter to 'image' for display campaigns, 'all' for video campaigns
        this.activeFileTypeFilter = this.campaignMediaType !== 'video' ? 'image' : 'all';
        this.searchQuery = '';
        this.selectedCompany = this.companySelected;
        this.selectedItems = [];
        this.initializeData();
      }
    },

  },
  mounted() {
    this.selectedCompany = this.companySelected;
    this.selectedItems = [];
    // Initialize local filter from prop
    this.localActiveDimensionFilter = this.$props.activeDimensionFilter || 'all';
  },
  methods: {
    ...mapActions(['SimplifiGetMedia','GetDownloadMediaToken']),
    async initializeData() {
      await this.getMedia();
    },
    /**
     * Cleanup old upload notifications properly (close, not just hide)
     * This prevents memory leaks and notification accumulation
     */
    cleanupOldUploadNotifications() {
      const existingNotifications = document.querySelectorAll('.el-notification');
      existingNotifications.forEach(notif => {
        const content = notif.querySelector('.el-notification__content');
        if (content && content.textContent.includes('Uploading')) {
          // Try to close notification properly
          const closeBtn = notif.querySelector('.el-notification__closeBtn');
          if (closeBtn) {
            closeBtn.click();
          } else {
            // Fallback: remove from DOM if close button not found
            notif.remove();
          }
        }
      });
    },
    /**
     * Process upload queue - start next upload if slot available
     */
    processUploadQueue() {
      // Remove completed/failed uploads from activeUploads
      this.activeUploads = this.activeUploads.filter(upload => {
        const queueItem = this.uploadQueue.find(q => q.uploadId === upload.uploadId);
        return queueItem && (queueItem.status === 'uploading' || queueItem.status === 'pending');
      });

      // Start next upload if we have slot available
      const pendingCount = this.uploadQueue.filter(q => q.status === 'pending').length;
      const activeCount = this.activeUploads.length;
      
      if (pendingCount > 0 && activeCount < this.maxConcurrentUploads) {
        // Find first pending upload
        const nextUpload = this.uploadQueue.find(q => q.status === 'pending');
        if (nextUpload && nextUpload.startUpload) {
          // Mark as uploading and add to active uploads
          nextUpload.status = 'uploading';
          this.activeUploads.push({ uploadId: nextUpload.uploadId });
          
          // Start the upload using the stored callback
          nextUpload.startUpload();
        } else {
          console.warn('[MediaUpload] Cannot start queued upload:', {
            found: !!nextUpload,
            hasStartUpload: !!(nextUpload && nextUpload.startUpload)
          });
        }
      }
    },
    /**
     * Remove upload from queue and cleanup
     */
    removeUploadFromQueue(uploadId) {
      const index = this.uploadQueue.findIndex(q => q.uploadId === uploadId);
      if (index !== -1) {
        const upload = this.uploadQueue[index];
        
        // Cleanup notification
        if (upload.notification) {
          try {
            upload.notification.close();
          } catch (e) {
            console.warn('[MediaUpload] Error closing notification:', e);
          }
        }
        
        // Remove from queue
        this.uploadQueue.splice(index, 1);
        
        // Remove from active uploads
        this.activeUploads = this.activeUploads.filter(u => u.uploadId !== uploadId);
        
        // Process next in queue
        this.processUploadQueue();
      } else {
        console.warn('[MediaUpload] Upload not found in queue:', uploadId);
      }
    },
    updateFilteredGroups() {
      const query = this.searchQuery.toLowerCase().trim();
      
      // Get allowed ad file types based on campaign media type
      const allowedAdFileTypes = this.getAllowedAdFileTypes(this.campaignMediaType);
      
      // For video campaign: show all videos in a single list (no dimension grouping)
      if (this.campaignMediaType === 'video') {
        let videoMedia = this.mediaData.filter(item => {
          const matchesAdType = this.isMediaAllowedForCampaign(item, allowedAdFileTypes);
          const matchesFileTypeFilter = this.matchesFileTypeFilter(item);
          return matchesAdType && matchesFileTypeFilter;
        });
        
        // Apply search filter
        if (query) {
          videoMedia = videoMedia.filter(item => 
            (item.name || item.media_name || '').toLowerCase().includes(query)
          );
        }
        
        // Sort by name
        videoMedia.sort((a, b) => {
          const nameA = (a.name || a.media_name || '').toLowerCase();
          const nameB = (b.name || b.media_name || '').toLowerCase();
          return nameA.localeCompare(nameB);
        });
        
        this.displayedGroups = videoMedia;
        return;
      }
      
      // For display campaign: group by dimensions
      let processedGroups = this.allowedDims.map(dim => {
        // Filter media by dimension AND ad file type AND file type filter
        const mediaInDim = this.mediaData.filter(item => {
          const matchesDimension = this.matchDimension(item, dim);
          const matchesAdType = this.isMediaAllowedForCampaign(item, allowedAdFileTypes);
          const matchesFileTypeFilter = this.matchesFileTypeFilter(item);
          return matchesDimension && matchesAdType && matchesFileTypeFilter;
        });
        return {
          ...dim,
          dimensionKey: `${dim.w}x${dim.h}`,
          media: mediaInDim,
        };
      });
      if (this.localActiveDimensionFilter === 'available') {
        processedGroups = processedGroups.filter(group => group.media.length > 0);
      } else if (this.localActiveDimensionFilter !== 'all') {
        processedGroups = processedGroups.filter(group => group.dimensionKey === this.localActiveDimensionFilter);
      }
      if (query) {
        processedGroups = processedGroups.map(group => ({
          ...group,
          media: group.media.filter(item => (item.name || item.media_name || '').toLowerCase().includes(query)),
        }));
        processedGroups = processedGroups.filter(group => group.media.length > 0);
      }

      // Sort groups by dimensions (width first, then height)
      processedGroups.sort((a, b) => {
        if (a.w !== b.w) {
          return a.w - b.w; // Sort by width first
        }
        return a.h - b.h; // Then by height
      });

      this.displayedGroups = processedGroups;
    },
    /**
     * Get allowed ad file types for a campaign media type
     */
    getAllowedAdFileTypes(mediaType) {
      if (mediaType === 'video') {
        return [6]; // Video only
      }
      return [1, 9]; // Image, HTML5 (for display)
    },
    
    /**
     * Check if media item matches the active file type filter
     */
    matchesFileTypeFilter(item) {
      if (this.activeFileTypeFilter === 'all') {
        return true; // Show all types
      }
      
      const adFileTypeId = this.detectAdFileType(item);
      
      if (this.activeFileTypeFilter === 'image') {
        return adFileTypeId === 1; // Image only
      }
      
      if (this.activeFileTypeFilter === 'html5') {
        return adFileTypeId === 9; // HTML5 only
      }
      
      return true; // Default: show all
    },
    
    /**
     * Detect ad file type from media URL or filename
     */
    detectAdFileType(mediaItem) {
      // Check if ad_file_type_id is explicitly set
      if (mediaItem.ad_file_type_id) {
        return mediaItem.ad_file_type_id;
      }
      
      // Detect from filename (more reliable than URL)
      const fileName = (mediaItem.name || mediaItem.media_name || '').toLowerCase();
      const url = (mediaItem.media || mediaItem.url || '').toLowerCase();
      
      // Combine filename and URL for detection
      const combined = fileName + ' ' + url;
      
      // Check for video extensions (check filename first, then URL)
      if (combined.match(/\.(mp4|mov|mpeg)(\?|$| )/i)) {
        return 6; // Video
      }
      
      // Check for HTML5 ZIP (check filename first, then URL)
      if (combined.match(/\.zip(\?|$| )/i)) {
        return 9; // HTML5
      }
      
      // Check for image extensions (check filename first, then URL)
      if (combined.match(/\.(jpg|jpeg|png|gif)(\?|$| )/i)) {
        return 1; // Image
      }
      
      // Default to image if unknown (backward compatibility)
      return 1;
    },
    
    /**
     * Check if media is allowed for campaign type
     */
    isMediaAllowedForCampaign(mediaItem, allowedAdFileTypes) {
      const adFileTypeId = this.detectAdFileType(mediaItem);
      return allowedAdFileTypes.includes(adFileTypeId);
    },
    
    /**
     * Read file header (magic bytes) to detect actual file type
     */
    readFileHeader(file, bytesToRead = 12) {
      return new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.onload = (e) => {
          const arrayBuffer = e.target.result;
          const uint8Array = new Uint8Array(arrayBuffer);
          resolve(uint8Array);
        };
        reader.onerror = reject;
        // Read only the first N bytes
        const blob = file.slice(0, bytesToRead);
        reader.readAsArrayBuffer(blob);
      });
    },
    
    /**
     * Detect file type from magic bytes (file header)
     */
    detectFileTypeFromMagicBytes(uint8Array) {
      if (!uint8Array || uint8Array.length < 4) {
        return null;
      }
      
      // Convert to hex string for easier pattern matching
      const hex = Array.from(uint8Array)
        .map(b => b.toString(16).padStart(2, '0'))
        .join('')
        .toUpperCase();
      
      // JPEG: FF D8 FF
      if (hex.startsWith('FFD8FF')) {
        return 'image';
      }
      
      // PNG: 89 50 4E 47 0D 0A 1A 0A
      if (hex.startsWith('89504E470D0A1A0A')) {
        return 'image';
      }
      
      // GIF: 47 49 46 38 (GIF8)
      if (hex.startsWith('47494638')) {
        return 'image';
      }
      
      // MP4: 00 00 00 ?? 66 74 79 70 (ftyp box)
      if (hex.match(/^000000[0-9A-F]{2}66747970/)) {
        return 'video';
      }
      
      // QuickTime/MOV: 00 00 00 ?? 66 74 79 70 71 74 20 20
      if (hex.match(/^000000[0-9A-F]{2}6674797071742020/)) {
        return 'video';
      }
      
      // ZIP: 50 4B 03 04 or 50 4B 05 06 or 50 4B 07 08
      if (hex.startsWith('504B0304') || hex.startsWith('504B0506') || hex.startsWith('504B0708')) {
        return 'zip';
      }
      
      // AVI: 52 49 46 46 ?? ?? ?? ?? 41 56 49 20 (RIFF...AVI )
      if (hex.startsWith('52494646') && hex.length >= 24 && hex.substring(16, 24) === '41564920') {
        return 'video';
      }
      
      return null; // Unknown type
    },
    
    matchDimension(item, dim) {
      if (!item || !dim) return false;
      
      // For files without dimensions (ZIP, Video), show in all dimension groups
      // OR match if dimensions exist and match
      if (!item.dimensions) {
        // Video and HTML5 files don't have dimensions - show in all groups
        const adFileTypeId = this.detectAdFileType(item);
        if (adFileTypeId === 6 || adFileTypeId === 9) {
          return true; // Show video/ZIP in all dimension groups
        }
        return false; // Images without dimensions don't match
      }
      
      // For files with dimensions, match exactly
      return item.dimensions.replace(/\s/g, '') === `${dim.w}x${dim.h}`;
    },
    openUpload(dim) {
      if (this.isDeletingMedia) return;
      this.uploadTargetDim = dim;
      this.$refs.upload.$el.querySelector('input').click();
    },
    openUploadVideo() {
      if (this.isDeletingMedia) return;
      // For video campaign, no specific dimension required
      this.uploadTargetDim = null;
      this.$refs.upload.$el.querySelector('input').click();
    },
    onCompanyChange() {
      this.isLoadingMedia = true;
      this.searchQuery = '';
      this.localActiveDimensionFilter = 'all';
      this.getMedia();
    },
    async getMedia() {
      this.isLoadingMediaError = false;
      try {
        if (!this.selectedCompany) {
          this.mediaData = [];
          return; 
        }
        let selectedCompanyItem = this.companyList.find(item => item.id == this.selectedCompany);
        
        if (!selectedCompanyItem) {
          selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
        }
        const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
        if (!user_id) {
          this.mediaData = [];
        } else {
          const payloadGetMedia = { user_id };
          const response = await this.SimplifiGetMedia({ data: payloadGetMedia });
          
          if (response.result === 'success') {
            this.mediaData = response.media || [];
            this.storageUsedBytes = response.occupied_storage;
          } else {
            this.mediaData = [];
            this.isLoadingMediaError = true; 
          }
        }
      } catch (error) {
        this.isLoadingMediaError = true;
        this.mediaData = [];
      } finally {
        this.updateFilteredGroups();
        this.isLoadingMedia = false;
      }
    },
    noopUpload() {
      // Required by Element UI; can be empty
      return;
    },
    /**
     * Determine storage path based on file type
     */
    getStoragePathForFile(file) {
      const fileType = file.raw.type || '';
      const fileName = file.raw.name || '';
      const lowerFileName = fileName.toLowerCase();
      
      // Check for ZIP (HTML5)
      if (fileType === 'application/zip' || lowerFileName.endsWith('.zip')) {
        return 'users/media/html5';
      }
      
      // Check for video types
      if (fileType.startsWith('video/') || 
          lowerFileName.match(/\.(mp4|mov|mpeg)$/i)) {
        return 'users/media/videos';
      }
      
      // Default to images
      return 'users/media';
    },
    
    handleChange_old(file) {
      let selectedCompanyItem = this.companyList.find(item => item.id == this.selectedCompany);
      if (!selectedCompanyItem) {
        selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      }
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
      if(!user_id) {
        this.$notify({ 
          type: 'danger', 
          message: 'User ID not found.', 
          icon: 'fas fa-bug'
        });
        return;
      }

      const loadingNotification = Notification({
        message: `
          <p style="color: #000; font-size: 20px; font-weight: bold;">
          <i class="el-icon-loading" style="margin-right: 10px;"></i> Uploading Media...
          </p>
          <p style="color: #000; font-size: 14px; margin-top: 10px;">
            We're Uploading your media.
          </p>
        `,
        duration: 0,
        showClose: false, // Disable close button during upload
        dangerouslyUseHTMLString: true,
      });      

      const reader = new FileReader();
      reader.onload = e => {
        const img = new Image();
        img.onload = () => {
          const { width, height } = img;
        if (this.uploadTargetDim) {
          if (width !== this.uploadTargetDim.w || height !== this.uploadTargetDim.h) {
            loadingNotification.close()
            this.$notify({
              type: 'danger',
              message: `Image must be exactly ${this.uploadTargetDim.w}x${this.uploadTargetDim.h}, but the selected file is ${width}x${height}.`,
              icon: 'fas fa-exclamation-triangle'
            });
            this.uploadTargetDim = null;
            return;
          }
        } else {
          const isValid = this.allowedDims.some(d => d.w === width && d.h === height);
          if (!isValid) {
            loadingNotification.close()
            this.$notify({
              type: 'danger',
              message: `Invalid dimension ${width}x${height}.<br> Valid dimensions: ${this.allowedDims.map(d => d.w + "x" + d.h).join(", ")}`,
              icon: 'fas fa-bug'
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
            return;
          }
        }

          const formData = new FormData();
          formData.append('user_id', user_id);
          formData.append('file', file.raw);


          axios.post(process.env.VUE_APP_APISERVER_URL + '/api/media/upload', formData)
            .then(() => {
              this.getMedia();
              loadingNotification.close()
              this.$notify({
                type: 'success',
                message: 'Upload successful!',
                icon: 'fas fa-check-circle'
              });
            })
            .catch(error => {
              const message = error.response.data.message || 'Something went wrong.';
              loadingNotification.close()
              this.$notify({
                type: 'danger', message, icon: 'fas fa-exclamation-triangle'
              });
            })
            .finally(() => {
              this.uploadTargetDim = null;
            });
        };
        img.src = e.target.result;
      };
      reader.readAsDataURL(file.raw);
    },
    async handleChange(file) {
      if (this.isDeletingMedia) {
        this.notifyMediaActionBlocked('Wait until media deletion finishes before uploading new files.');
        return;
      }
      // Follow existing flow: get user_id from selectedCompany (not from userData)
      let selectedCompanyItem = this.companyList.find(item => item.id == this.selectedCompany);
      if (!selectedCompanyItem) {
        selectedCompanyItem = this.companyList.find(item => item.company_name == this.selectedCompany);
      }
      const user_id = selectedCompanyItem ? selectedCompanyItem.id : null;
      
      if (!user_id) {
        this.$notify({ 
          type: 'danger', 
          message: 'Please select a client first.', 
          icon: 'fas fa-bug'
        });
        return;
      }
      
      const loadingNotification = Notification({
        message: `
          <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
            <i class="el-icon-loading" style="margin-right: 10px; font-size: 18px; animation: rotating 2s linear infinite;"></i>
            Validating file...
          </p>
          <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
            Please wait while we validate your file.
          </p>
        `,
        showClose: false, // Disable close button during validation
        duration: 0,
        dangerouslyUseHTMLString: true,
      });

      // First, validate file type using magic bytes (more reliable than MIME type)
      // This prevents issues when users rename video files to image extensions
      let actualFileType = null;
      try {
        const fileHeader = await this.readFileHeader(file.raw, 12); // Read first 12 bytes
        actualFileType = this.detectFileTypeFromMagicBytes(fileHeader);
      } catch (error) {
        console.warn('Failed to read file header, falling back to MIME type:', error);
      }
      
      // Use magic bytes detection if available, otherwise fall back to MIME type
      // Priority: magic bytes > MIME type (to prevent renamed files from bypassing validation)
      const isImage = actualFileType === 'image' || (actualFileType === null && file.raw && file.raw.type && file.raw.type.startsWith('image/'));
      const isVideo = actualFileType === 'video' || (actualFileType === null && file.raw && file.raw.type && file.raw.type.startsWith('video/'));
      const isZip = actualFileType === 'zip' || (actualFileType === null && file.raw && (file.raw.type === 'application/zip' || file.raw.name.toLowerCase().endsWith('.zip')));
      
      // Validate file type against campaign media type
      const allowedAdFileTypes = this.getAllowedAdFileTypes(this.campaignMediaType);
      let detectedAdFileTypeId = null;
      
      if (isImage) {
        detectedAdFileTypeId = 1; // Image
      } else if (isVideo) {
        detectedAdFileTypeId = 6; // Video
      } else if (isZip) {
        detectedAdFileTypeId = 9; // HTML5
      }
      
      // Check if file type is allowed for this campaign type
      if (detectedAdFileTypeId && !allowedAdFileTypes.includes(detectedAdFileTypeId)) {
        loadingNotification.close();
        
        const campaignTypeName = this.campaignMediaType === 'video' ? 'Video' : 'Display';
        const allowedTypes = this.campaignMediaType === 'video' ? 'Video' : 'Image and HTML5 (ZIP)';
        const fileTypeName = detectedAdFileTypeId === 1 ? 'Image' : (detectedAdFileTypeId === 6 ? 'Video' : 'HTML5 (ZIP)');
        
        // Special message for renamed files (both directions)
        const isRenamedVideo = actualFileType === 'video' && file.raw.name.toLowerCase().match(/\.(jpg|jpeg|png|gif)$/);
        const isRenamedImage = actualFileType === 'image' && file.raw.name.toLowerCase().match(/\.(mp4|mov|mpeg)$/);
        let additionalMessage = '';
        
        if (isRenamedVideo) {
          additionalMessage = '<br><span style="color: #E6A23C; font-size: 13px; font-weight: 600;">⚠️ This file is actually a video file that was renamed. Renaming video files to image extensions is not supported.</span>';
        } else if (isRenamedImage) {
          additionalMessage = '<br><span style="color: #E6A23C; font-size: 13px; font-weight: 600;">⚠️ This file is actually an image file that was renamed. Renaming image files to video extensions is not supported.</span>';
        }
        
        Notification({
          message: `
            <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
              <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
              File Type Not Allowed
            </p>
            <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
              ${fileTypeName} files are not allowed for ${campaignTypeName} campaigns.${additionalMessage}<br>
              <span style="color: #909399; font-size: 13px;">Allowed file types: ${allowedTypes}</span>
            </p>
          `,
          duration: 5000,
          dangerouslyUseHTMLString: true,
        });
        
        const idx = this.fileList.findIndex(f => f.uid === file.uid);
        if (idx !== -1) this.fileList.splice(idx, 1);
        return;
      }
      
      const uploadFolder = this.getStoragePathForFile(file);
      
      // Store video dimensions to pass to backend
      let videoDimensions = null;

      const doUpload = (videoWidth = null, videoHeight = null) => {
        // Store video dimensions if provided
        if (videoWidth && videoHeight) {
          videoDimensions = `${videoWidth}x${videoHeight}`;
        }
        
        // Close validation notification
        loadingNotification.close();
        
        // Create unique upload ID
        const uploadId = Date.now() + '_' + Math.random().toString(36).substr(2, 9);
        
        // Create queue item first (will be populated with startUpload callback)
        const queueItem = {
          uploadId: uploadId,
          file: file,
          user_id: user_id,
          uploadFolder: uploadFolder,
          videoDimensions: videoDimensions,
          status: 'pending',
          notification: null,
          resumableInstance: null,
          startUpload: null // Will be set below
        };
        
        // CRITICAL: Store reference to Vue component instance for use in XHR interceptor
        const vueInstance = this;
        // Create function to start upload (will be called immediately or from queue)
        const startUpload = () => {
          // CRITICAL: Ensure we start with a clean state for this upload
          // Mark as uploading and add to active uploads
          queueItem.status = 'uploading';
          vueInstance.activeUploads.push({ uploadId: uploadId });
          const fileSizeMB = (file.raw.size / (1024 * 1024)).toFixed(2);
          let progressNotification = null;
          let uploadStarted = false; // Track if upload has actually started
          let uploadSuccess = false; // Track if upload succeeded
          let errorNotificationShown = false; // Prevent duplicate error notifications
          let lastProgressUpdate = 0; // Track last progress update time for throttling
          let lastProgressPercent = -1; // Track last displayed progress percentage
          let notificationElement = null; // Store reference to notification DOM element
          
          // Show progress notification (only once)
          const fileName = file.raw.name.length > 30 
            ? file.raw.name.substring(0, 30) + '...' 
            : file.raw.name;
          const initialMessage = file.raw.size > 1024 * 1024
            ? `${fileName} (${fileSizeMB} MB)`
            : fileName;
          
          // Calculate offset based on number of active upload notifications
          // This ensures new notifications appear below existing ones
          // Count only upload notifications that are currently visible (uploading status)
          const activeUploadNotifications = vueInstance.uploadQueue.filter(q => 
            q.status === 'uploading' && q.notification
          ).length;
          
          // Count visible upload notifications in DOM by checking for "Uploading File" text
          // This is more accurate than counting all notifications
          const allNotifications = document.querySelectorAll('.el-notification');
          let visibleUploadCount = 0;
          allNotifications.forEach(notif => {
            const content = notif.querySelector('.el-notification__content');
            if (content && content.textContent.includes('Uploading File')) {
              visibleUploadCount++;
            }
          });
          
          // Use the maximum of both to ensure proper stacking
          // Each notification is approximately 90px tall (including margin)
          // Start from 20px offset, then add 90px for each existing notification
          const notificationCount = Math.max(activeUploadNotifications, visibleUploadCount);
          const notificationOffset = 20 + (notificationCount * 90);
          
          progressNotification = Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-loading" style="margin-right: 10px; font-size: 18px; animation: rotating 2s linear infinite;"></i>
                Uploading File...
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                ${initialMessage}<br>
                <span style="color: #909399; font-size: 13px;">Progress: 0%</span>
              </p>
            `,
            showClose: false, // Disable close button during upload progress
            duration: 0,
            dangerouslyUseHTMLString: true,
            offset: notificationOffset, // Position notification below existing ones
            onClose: () => {
              notificationElement = null;
            }
          });
          
          // Store notification in queue item for cleanup
          queueItem.notification = progressNotification;
          
          // Store reference to notification element for direct DOM updates
          setTimeout(() => {
            const notifications = document.querySelectorAll('.el-notification');
            if (notifications.length > 0) {
              notificationElement = notifications[notifications.length - 1];
            }
          }, 100);

          // Use Resumable.js for chunked uploads (handles large files)
          const uploadUrl = process.env.VUE_APP_APISERVER_URL + '/api/media/upload';
          
          // Variables for error handling
          let uploadCanceled = false;
          let resumableInstance = null; // Will be set after resumable is created
          const activeXHRRequests = []; // Track all active XHR requests to abort them on error
          

          // Helper function to handle upload errors
          const handleUploadError = (errorMessage) => {
            // Don't show duplicate error notifications
            if (errorNotificationShown) {
              return;
            }

            errorNotificationShown = true;
            uploadCanceled = true; // Mark as canceled globally

            // STEP 1: Cancel upload immediately - use multiple methods to ensure it stops
            try {
              if (resumableInstance) {
                // Method 1: Abort ALL active XHR requests FIRST (before canceling Resumable)
                const xhrsToAbort = [...activeXHRRequests];
                xhrsToAbort.forEach(xhr => {
                  try {
                    if (xhr.readyState !== 4 && xhr.readyState !== 0) {
                      // console.log('[MediaUpload] Aborting active XHR request');
                      xhr.abort();
                    }
                  } catch (e) {
                    console.warn('[MediaUpload] Error aborting XHR:', e);
                  }
                });
                activeXHRRequests.length = 0; // Clear array
                
                // Method 2: Cancel all uploads
                resumableInstance.cancel();
                
                // Method 3: Pause uploads
                resumableInstance.pause();
                
                // Method 4: Stop upload if it's currently uploading
                if (resumableInstance.isUploading && resumableInstance.isUploading()) {
                  resumableInstance.cancel();
                }
                
                // Method 5: Abort all chunks in all files
                if (resumableInstance.files && resumableInstance.files.length > 0) {
                  resumableInstance.files.forEach(file => {
                    try {
                      // Abort all chunks for this file
                      if (file.chunks && Array.isArray(file.chunks)) {
                        file.chunks.forEach(chunk => {
                          try {
                            if (chunk.xhr && chunk.xhr.readyState !== 4) {
                              chunk.xhr.abort();
                            }
                          } catch (e) {
                            console.warn('[MediaUpload] Error aborting chunk XHR:', e);
                          }
                        });
                      }
                      // Cancel individual file upload
                      if (file.abort) {
                        file.abort();
                      }
                      resumableInstance.removeFile(file);
                    } catch (e) {
                      console.warn('[MediaUpload] Error removing file:', e);
                    }
                  });
                }
                
                // Method 6: Clear files array completely
                resumableInstance.files = [];
                
                // Method 7: Stop all chunks that might be in progress
                if (resumableInstance.opts) {
                  // Disable simultaneous uploads to prevent new chunks
                  resumableInstance.opts.simultaneousUploads = 0;
                  // Also set maxFiles to 0 to prevent new files
                  resumableInstance.opts.maxFiles = 0;
                }
                
                // console.log('[MediaUpload] Upload canceled - all methods applied');
              }
            } catch (e) {
              console.warn('[MediaUpload] Error canceling upload:', e);
            }

            // STEP 2: Show error notification FIRST
            Notification({
              message: `
                <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                  <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                  Upload Failed
                </p>
                <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                  ${errorMessage}
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            });

            // STEP 3: Close progress notification AFTER error notification is shown
            setTimeout(() => {
              if (progressNotification) {
                try {
                  progressNotification.close();
                  progressNotification = null; // Clear reference to prevent reuse
                } catch (e) {
                  console.warn('[MediaUpload] Error closing progress notification:', e);
                }
              }
              
              // Also try to close by finding the notification element in DOM
              try {
                const notifications = document.querySelectorAll('.el-notification');
                notifications.forEach(notif => {
                  const content = notif.querySelector('.el-notification__content');
                  if (content && content.textContent.includes('Uploading')) {
                    const style = window.getComputedStyle(notif);
                    if (style.display !== 'none' && style.visibility !== 'hidden') {
                      notif.style.display = 'none';
                      setTimeout(() => {
                        if (notif.parentNode) {
                          notif.parentNode.removeChild(notif);
                        }
                      }, 300);
                    }
                  }
                });
              } catch (e) {
                console.warn('[MediaUpload] Error closing progress notification via DOM:', e);
              }
            }, 150); // Small delay to ensure error notification is shown first

            this.uploadTargetDim = null;
            
            // Cleanup: Restore XHR interceptors to original after error
            // Do this in a timeout to ensure it happens after all error handling is complete
            setTimeout(() => {
              try {
                if (XMLHttpRequest.prototype._emmOriginalOpen) {
                  XMLHttpRequest.prototype.open = XMLHttpRequest.prototype._emmOriginalOpen;
                }
                if (XMLHttpRequest.prototype._emmOriginalSend) {
                  XMLHttpRequest.prototype.send = XMLHttpRequest.prototype._emmOriginalSend;
                }
                // Clear global references
                delete XMLHttpRequest.prototype._emmOriginalOpen;
                delete XMLHttpRequest.prototype._emmOriginalSend;
              } catch (e) {
                console.warn('[MediaUpload] Error restoring XHR interceptors in handleUploadError:', e);
              }
            }, 200);
          };

          // Intercept XMLHttpRequest to catch HTTP errors before Resumable.js processes them
          // CRITICAL: ALWAYS restore original interceptors FIRST (synchronously) to avoid conflicts with previous uploads
          // This ensures that any cleanup from previous uploads is completed before starting a new one
          try {
            // Restore to original if exists
            if (XMLHttpRequest.prototype._emmOriginalOpen) {
              XMLHttpRequest.prototype.open = XMLHttpRequest.prototype._emmOriginalOpen;
            } else {
              // If no original stored, get the current (which should be native)
              XMLHttpRequest.prototype._emmOriginalOpen = XMLHttpRequest.prototype.open;
            }
            
            if (XMLHttpRequest.prototype._emmOriginalSend) {
              XMLHttpRequest.prototype.send = XMLHttpRequest.prototype._emmOriginalSend;
            } else {
              // If no original stored, get the current (which should be native)
              XMLHttpRequest.prototype._emmOriginalSend = XMLHttpRequest.prototype.send;
            }
          } catch (e) {
            console.warn('[MediaUpload] Error restoring XHR interceptors at start:', e);
            // Fallback: try to get native methods
            if (!XMLHttpRequest.prototype._emmOriginalOpen) {
              XMLHttpRequest.prototype._emmOriginalOpen = XMLHttpRequest.prototype.open;
            }
            if (!XMLHttpRequest.prototype._emmOriginalSend) {
              XMLHttpRequest.prototype._emmOriginalSend = XMLHttpRequest.prototype.send;
            }
          }
          
          // Store original methods for this upload instance (these are now guaranteed to be clean)
          const originalXHROpen = XMLHttpRequest.prototype._emmOriginalOpen;
          const originalXHRSend = XMLHttpRequest.prototype._emmOriginalSend;

          XMLHttpRequest.prototype.open = function(method, url, ...args) {
            this._url = url;
            this._isUploadRequest = url.includes('/api/media/upload');
            return originalXHROpen.apply(this, [method, url, ...args]);
          };

          XMLHttpRequest.prototype.send = function(data) {
            const xhr = this;
            
            // CRITICAL: Tag this XHR with the current upload ID
            if (xhr._isUploadRequest) {
              xhr._uploadId = uploadId;
            }
            
            // CRITICAL: Only process XHR requests that belong to this upload
            // If XHR doesn't have uploadId or doesn't match, it belongs to a different upload
            if (xhr._isUploadRequest && (!xhr._uploadId || xhr._uploadId !== uploadId)) {
              // This XHR belongs to a different upload, let it proceed normally
              return originalXHRSend.apply(this, arguments);
            }
            
            // CRITICAL: If upload is already canceled, abort immediately before sending
            if (xhr._isUploadRequest && xhr._uploadId === uploadId && uploadCanceled) {
              console.warn('[MediaUpload] XHR send blocked - upload already canceled', {
                uploadId: uploadId,
                xhrUploadId: xhr._uploadId,
                url: xhr._url
              });
              // console.warn('[MediaUpload] XHR send blocked - upload already canceled', {
              //   url: xhr._url,
              //   uploadId: uploadId,
              //   xhrUploadId: xhr._uploadId,
              //   uploadCanceled: uploadCanceled,
              //   timestamp: new Date().toISOString()
              // });
              // console.trace('[MediaUpload] Stack trace for canceled upload');
              try {
                xhr.abort();
              } catch (e) {
                console.warn('[MediaUpload] Error aborting canceled XHR:', e);
              }
              return; // Don't send the request at all
            }
            
            // Only intercept upload requests
            if (xhr._isUploadRequest) {
              // Only track XHR requests that belong to this upload
              if (xhr._uploadId === uploadId) {
                // Track this XHR request so we can abort it later if needed
                activeXHRRequests.push(xhr);
              }
              
              // Remove from tracking when request completes (success or error)
              const removeFromTracking = () => {
                if (xhr._uploadId === uploadId) {
                  const index = activeXHRRequests.indexOf(xhr);
                  if (index > -1) {
                    activeXHRRequests.splice(index, 1);
                  }
                }
              };
              
              const originalOnReadyStateChange = xhr.onreadystatechange;
              
              xhr.onreadystatechange = function() {
                // CRITICAL: Only process XHR requests that belong to this upload
                if (xhr._uploadId !== uploadId) {
                  // This XHR belongs to a different upload, let it proceed normally
                  if (originalOnReadyStateChange) {
                    originalOnReadyStateChange.apply(this, arguments);
                  }
                  return;
                }
                
                // CRITICAL: Check if canceled at the start of every state change
                if (uploadCanceled) {
                  // console.log('[MediaUpload] XHR onreadystatechange blocked - upload canceled', { uploadId });
                  try {
                    if (xhr.readyState !== 4) {
                      xhr.abort();
                    }
                  } catch (e) {
                    console.warn('[MediaUpload] Error aborting XHR in state change:', e);
                  }
                  removeFromTracking();
                  return; // Don't process further
                }
                
                if (xhr.readyState === 4) {
                  // Request completed, remove from tracking
                  removeFromTracking();
                  
                  // Check for HTTP error status (4xx, 5xx)
                  if (xhr.status >= 400 && !uploadCanceled) {
                    // Read response text BEFORE aborting
                    const responseText = xhr.responseText || '';
                    
                    console.error('[MediaUpload] HTTP error intercepted:', {
                      status: xhr.status,
                      statusText: xhr.statusText,
                      url: xhr._url,
                      response: responseText,
                      responseLength: responseText.length
                    });
                    
                    // Mark as canceled to prevent further requests
                    uploadCanceled = true;
                    
                    // CRITICAL: Abort ALL pending XHR requests immediately
                    const pendingXHRs = [...activeXHRRequests];
                    pendingXHRs.forEach(pendingXHR => {
                      try {
                        if (pendingXHR !== xhr && pendingXHR.readyState !== 4) {
                          // console.log('[MediaUpload] Aborting pending XHR request');
                          pendingXHR.abort();
                        }
                      } catch (e) {
                        console.warn('[MediaUpload] Error aborting pending XHR:', e);
                      }
                    });
                    activeXHRRequests.length = 0; // Clear array
                    
                    // Parse error response from backend
                    let errorMessage = 'Upload failed. Please try again.';
                    try {
                      if (responseText) {
                        const errorResponse = JSON.parse(responseText);
                        // Backend always returns error message in 'message' field
                        if (errorResponse.message) {
                          errorMessage = errorResponse.message;
                        }
                      }
                    } catch (e) {
                      console.warn('[MediaUpload] Failed to parse error response:', e);
                      // If parsing fails, use status text as fallback
                      errorMessage = xhr.statusText || `HTTP ${xhr.status} Error`;
                    }
                    
                    // Abort this request (after reading response)
                    try {
                      xhr.abort();
                    } catch (e) {
                      console.warn('[MediaUpload] Error aborting XHR:', e);
                    }
                    
                    // CRITICAL: Restore XHR interceptors IMMEDIATELY after error to prevent blocking next upload
                    // Do this synchronously before calling handleUploadError to ensure clean state
                    try {
                      if (XMLHttpRequest.prototype._emmOriginalOpen) {
                        XMLHttpRequest.prototype.open = XMLHttpRequest.prototype._emmOriginalOpen;
                      }
                      if (XMLHttpRequest.prototype._emmOriginalSend) {
                        XMLHttpRequest.prototype.send = XMLHttpRequest.prototype._emmOriginalSend;
                      }
                      // Clear global references
                      delete XMLHttpRequest.prototype._emmOriginalOpen;
                      delete XMLHttpRequest.prototype._emmOriginalSend;
                    } catch (e) {
                      console.warn('[MediaUpload] Error restoring XHR interceptors in error handler:', e);
                    }
                    
                    // CRITICAL: Update queue item status BEFORE calling handleUploadError
                    // This ensures the queue knows this upload has failed
                    // Use vueInstance instead of this (this refers to XHR instance here)
                    const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
                    if (queueItem) {
                      queueItem.status = 'failed';
                      console.log('[MediaUpload] Queue item status updated to failed:', uploadId);
                    }
                    
                    // Handle error (this will cancel resumable and show notification)
                    handleUploadError(errorMessage);
                    
                    // CRITICAL: Remove from queue and process next IMMEDIATELY after error
                    // Don't wait for fileError event, as it might not fire for all error cases
                    setTimeout(() => {
                      console.log('[MediaUpload] Removing failed upload from queue:', uploadId);
                      vueInstance.removeUploadFromQueue(uploadId);
                    }, 50); // Small delay to ensure status is updated
                    
                    // Don't call original handler for error responses
                    return;
                  }
                }
                
                // Call original handler if exists and not canceled
                if (xhr._uploadId === uploadId && originalOnReadyStateChange && !uploadCanceled) {
                  originalOnReadyStateChange.apply(this, arguments);
                } else if (xhr._uploadId !== uploadId && originalOnReadyStateChange) {
                  // This XHR belongs to a different upload, call original handler
                  originalOnReadyStateChange.apply(this, arguments);
                }
              };
            }
            
            return originalXHRSend.apply(this, arguments);
          };

          const resumable = new Resumable({
            target: uploadUrl,
            query: {
              user_id: user_id,
              upload_folder: uploadFolder,
              upload_id: uploadId, // Add unique upload ID to prevent race conditions with concurrent uploads
              ...(videoDimensions ? { video_dimensions: videoDimensions } : {})
            },
            headers: {
              'Accept': 'application/json',
              'Authorization': 'Bearer ' + localStorage.getItem('access_token'),
              'X-File-Size': file.raw.size.toString() // Send total file size for early validation
            },
            // CRITICAL: Enable cookies for sticky session support with load balancer
            // This ensures session cookies are sent with each chunk request
            xhrFields: {
              withCredentials: true
            },
            testChunks: false,
            throttleProgressCallbacks: 1,
            maxFileSize: 200 * 1024 * 1024, // 200 MB max
            maxFiles: 1,
            simultaneousUploads: 1,
            chunkSize: 1 * 1024 * 1024, // 1 MB chunks
            maxFileSizeErrorCallback: (file, errorCount) => {
              // console.error('[MediaUpload] File too large error:', { file, errorCount });
              
              // CRITICAL: Update queue item status BEFORE showing error
              const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
              if (queueItem) {
                queueItem.status = 'failed';
                // console.log('[MediaUpload] Queue item status updated to failed (maxFileSize):', uploadId);
              }
              
              if (progressNotification) {
                progressNotification.close();
              }
              Notification({
                message: `
                  <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                    <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                    File Too Large
                  </p>
                  <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                    File size exceeds 200 MB limit.
                  </p>
                `,
                duration: 5000,
                dangerouslyUseHTMLString: true,
              });
              
              // CRITICAL: Remove from queue and process next IMMEDIATELY after error
              // This ensures the queue continues processing even after size validation errors
              setTimeout(() => {
                // console.log('[MediaUpload] Removing failed upload from queue (maxFileSize):', uploadId);
                vueInstance.removeUploadFromQueue(uploadId);
              }, 50); // Small delay to ensure status is updated
            }
          });
          
          // Store reference for error handler
          resumableInstance = resumable;
          queueItem.resumableInstance = resumable;

          // IMPORTANT: Set up event handlers BEFORE adding file
          // Event: File added - START UPLOAD HERE
          resumable.on('fileAdded', (resumableFile) => {
            // CRITICAL: Don't start upload if already canceled
            if (uploadCanceled) {
              // console.log('[MediaUpload] fileAdded ignored - upload already canceled');
              try {
                resumable.removeFile(resumableFile);
              } catch (e) {
                console.warn('[MediaUpload] Error removing file in fileAdded:', e);
              }
              return;
            }
            
            // Start upload when file is added (only if not canceled)
            if (!uploadCanceled) {
              resumable.upload();
            } else {
              // console.log('[MediaUpload] Upload not started - already canceled');
              try {
                resumable.removeFile(resumableFile);
              } catch (e) {
                console.warn('[MediaUpload] Error removing file:', e);
              }
            }
          });

          // Event: Upload start
          resumable.on('uploadStart', () => {
            // CRITICAL: Cancel if already marked as canceled
            if (uploadCanceled) {
              // console.log('[MediaUpload] uploadStart ignored - upload already canceled');
              resumable.cancel();
              return;
            }
            uploadStarted = true; // Mark that upload has actually started
          });

          // Event: Before upload
          resumable.on('beforeUpload', () => {
            // CRITICAL: Cancel if already marked as canceled
            if (uploadCanceled) {
              resumable.cancel();
              return;
            }
            uploadStarted = true; // Mark that upload is about to start
          });

          // Event: Chunk upload start
          resumable.on('chunkingStart', (resumableFile) => {
            // CRITICAL: Cancel if already marked as canceled
            if (uploadCanceled) {
              resumable.cancel();
              return;
            }
          });

          // Event: Chunk upload progress
          resumable.on('chunkingProgress', (resumableFile, ratio) => {
            // Progress tracking
          });

          // Event: Chunk upload complete
          resumable.on('chunkingComplete', (resumableFile) => {
            // Chunking complete
          });

          // Event: Chunk uploaded - check for errors from backend
          resumable.on('chunkUploaded', (resumableFile, resumableChunk, response) => {
            // CRITICAL: Stop processing if upload is already canceled
            if (uploadCanceled) {
              return;
            }
            
            // Check if backend returned an error in this chunk
            if (response) {
              try {
                const result = typeof response === 'string' ? JSON.parse(response) : response;
                if (result && result.result === 'error') {
                  // CRITICAL: Update queue item status BEFORE calling handleUploadError
                  // This ensures the queue knows this upload has failed
                  const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
                  if (queueItem) {
                    queueItem.status = 'failed';
                    // console.log('[MediaUpload] Queue item status updated to failed in chunkUploaded:', uploadId);
                  }
                  
                  // Use centralized error handler to ensure consistent behavior
                  handleUploadError(result.message || 'Upload failed. Please check your file and try again.');
                  
                  // CRITICAL: Remove from queue and process next IMMEDIATELY after error
                  // This ensures the queue continues processing even after validation errors
                  setTimeout(() => {
                    // console.log('[MediaUpload] Removing failed upload from queue (chunkUploaded):', uploadId);
                    vueInstance.removeUploadFromQueue(uploadId);
                  }, 50); // Small delay to ensure status is updated
                  
                  // IMPORTANT: Return immediately to prevent further processing
                  return;
                }
              } catch (e) {
                // Response is not JSON or not an error, continue upload
                // This is normal for successful chunk uploads
              }
            }
          });

          // Update progress
          resumable.on('fileProgress', (resumableFile) => {
            // CRITICAL: Stop updating progress if upload is canceled
            if (uploadCanceled) {
              return;
            }
            
            const percentCompleted = Math.floor(resumableFile.progress() * 100);
            const uploadedMB = ((resumableFile.size * resumableFile.progress()) / (1024 * 1024)).toFixed(2);
            const currentTime = Date.now();
            
            // Throttle updates: only update every 200ms OR every 1% progress OR at 100%
            const timeSinceLastUpdate = currentTime - lastProgressUpdate;
            const progressDiff = Math.abs(percentCompleted - lastProgressPercent);
            const shouldUpdate = timeSinceLastUpdate >= 200 || progressDiff >= 1 || percentCompleted === 100;
            
            if (shouldUpdate) {
              // Update notification message directly via DOM (smooth update without closing/reopening)
              const fileName = file.raw.name.length > 30 
                ? file.raw.name.substring(0, 30) + '...' 
                : file.raw.name;
              const fileInfo = file.raw.size > 1024 * 1024
                ? `${fileName} (${fileSizeMB} MB)`
                : fileName;
              const progressInfo = file.raw.size > 1024 * 1024
                ? `Progress: ${percentCompleted}% (${uploadedMB} MB / ${fileSizeMB} MB)`
                : `Progress: ${percentCompleted}%`;

              // Try to find notification element if not stored yet
              if (!notificationElement) {
                const notifications = document.querySelectorAll('.el-notification');
                // Find the notification that contains "Uploading File"
                Array.from(notifications).forEach((notif) => {
                  const content = notif.querySelector('.el-notification__content');
                  if (content && content.textContent.includes('Uploading File')) {
                    notificationElement = notif;
                  }
                });
              }

              // Update the message text directly in the DOM (update the second <p> tag)
              // Use requestAnimationFrame to ensure DOM is ready
              requestAnimationFrame(() => {
                if (notificationElement) {
                  const contentElement = notificationElement.querySelector('.el-notification__content');
                  
                  if (contentElement) {
                    const pElements = contentElement.querySelectorAll('p');
                    
                    // Since there are 3 p elements, we need to find the one with "Progress:" text
                    let progressPElement = null;
                    let progressPIndex = -1;
                    
                    // Find the p element that contains "Progress:"
                    Array.from(pElements).forEach((p, idx) => {
                      if (p.textContent && p.textContent.includes('Progress:')) {
                        progressPElement = p;
                        progressPIndex = idx;
                      }
                    });
                    
                    if (progressPElement) {
                      // Update the progress p element
                      const newHTML = `${fileInfo}<br><span style="color: #909399; font-size: 13px;">${progressInfo}</span>`;
                      progressPElement.innerHTML = newHTML;
                      // Force reflow to ensure update is visible
                      progressPElement.offsetHeight;
                    } else {
                      // Fallback: try to update all p elements
                      if (pElements.length >= 2) {
                        // Usually the second p contains the progress
                        const newHTML = `${fileInfo}<br><span style="color: #909399; font-size: 13px;">${progressInfo}</span>`;
                        pElements[1].innerHTML = newHTML;
                        pElements[1].offsetHeight;
                      }
                    }
                  } else {
                    console.warn('[MediaUpload] Content element not found!');
                  }
                } else {
                  console.warn('[MediaUpload] Notification element not found!');
                }
              });

              lastProgressUpdate = currentTime;
              lastProgressPercent = percentCompleted;
            }
          });

          // Handle successful upload
          resumable.on('fileSuccess', (resumableFile, response) => {
            uploadSuccess = true; // Mark upload as successful
            
            // Update queue item status
            // Use vueInstance to ensure correct context
            const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
            if (queueItem) {
              queueItem.status = 'completed';
            }
            
            if (progressNotification) {
              progressNotification.close();
            }
            
            // Cleanup: Restore XHR interceptors to original
            try {
              if (XMLHttpRequest.prototype._emmOriginalOpen) {
                XMLHttpRequest.prototype.open = XMLHttpRequest.prototype._emmOriginalOpen;
              }
              if (XMLHttpRequest.prototype._emmOriginalSend) {
                XMLHttpRequest.prototype.send = XMLHttpRequest.prototype._emmOriginalSend;
              }
              // Clear global references
              delete XMLHttpRequest.prototype._emmOriginalOpen;
              delete XMLHttpRequest.prototype._emmOriginalSend;
            } catch (e) {
              console.warn('[MediaUpload] Error restoring XHR interceptors:', e);
            }
            
            // Cleanup: Remove Resumable instance
            try {
              if (resumableInstance) {
                resumableInstance.cancel();
                resumableInstance.files = [];
              }
            } catch (e) {
              console.warn('[MediaUpload] Error cleaning up Resumable instance:', e);
            }
            
            try {
              const result = typeof response === 'string' ? JSON.parse(response) : response;
              vueInstance.getMedia();
              Notification({
                message: `
                  <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                    <i class="el-icon-success" style="margin-right: 10px; font-size: 18px; color: #67C23A;"></i>
                    Upload successful!
                  </p>
                  <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                    Your file has been uploaded successfully.
                  </p>
                `,
                duration: 3000,
                dangerouslyUseHTMLString: true,
              });
            } catch (e) {
              console.warn('[MediaUpload] Response parse error (non-JSON response):', e);
              console.log('[MediaUpload] Raw response:', response);
              // If response is not JSON, still consider it success (backend might return different format)
              vueInstance.getMedia();
              Notification({
                message: `
                  <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                    <i class="el-icon-success" style="margin-right: 10px; font-size: 18px; color: #67C23A;"></i>
                    Upload successful!
                  </p>
                  <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                    Your file has been uploaded successfully.
                  </p>
                `,
                duration: 3000,
                dangerouslyUseHTMLString: true,
              });
            }
            
            // Remove from queue and process next
            vueInstance.removeUploadFromQueue(uploadId);
            vueInstance.uploadTargetDim = null;
          });

          // Handle upload error - this fires when HTTP error occurs (4xx, 5xx)
          resumable.on('fileError', (resumableFile, message) => {
            let errorMessage = 'Upload failed. Please try again.';
            
            // Try to extract error message from various sources
            try {
              // Try parsing message as JSON
              const errorData = typeof message === 'string' ? JSON.parse(message) : message;
              if (errorData && errorData.message) {
                errorMessage = errorData.message;
              } else if (errorData && errorData.result === 'error' && errorData.message) {
                errorMessage = errorData.message;
              }
            } catch (e) {
              // Try to get error from resumableFile.error
              if (resumableFile.error) {
                try {
                  const fileError = typeof resumableFile.error === 'string' ? JSON.parse(resumableFile.error) : resumableFile.error;
                  if (fileError && fileError.message) {
                    errorMessage = fileError.message;
                  }
                } catch (e2) {
                  // Fallback to message string if available
                  if (typeof message === 'string' && message) {
                    errorMessage = message;
                  }
                }
              }
            }
            
            // Update queue item status
            // Use vueInstance to ensure correct context
            const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
            if (queueItem) {
              // Only update status if not already updated by XHR interceptor
              if (queueItem.status !== 'failed') {
                queueItem.status = 'failed';
                console.log('[MediaUpload] Queue item status updated to failed in fileError:', uploadId);
              } else {
                console.log('[MediaUpload] Queue item already marked as failed (from XHR interceptor):', uploadId);
              }
            }
            
            handleUploadError(errorMessage);
            
            // Cleanup: Remove Resumable instance
            // Note: XHR interceptors are already restored in the XHR error handler above
            // Note: removeUploadFromQueue is already called from XHR interceptor, so we only cleanup Resumable here
            setTimeout(() => {
              // Cleanup: Remove Resumable instance
              try {
                if (resumableInstance) {
                  resumableInstance.cancel();
                  resumableInstance.files = [];
                }
              } catch (e) {
                console.warn('[MediaUpload] Error cleaning up Resumable instance after error:', e);
              }
              
              // Check if upload is still in queue (might have been removed by XHR interceptor)
              const stillInQueue = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
              if (stillInQueue) {
                console.log('[MediaUpload] Upload still in queue, removing from fileError handler:', uploadId);
                vueInstance.removeUploadFromQueue(uploadId);
              } else {
                console.log('[MediaUpload] Upload already removed from queue (by XHR interceptor):', uploadId);
                // Still process queue in case there are pending uploads
                vueInstance.processUploadQueue();
              }
            }, 100);
          });

          // Event: Upload complete (all files)
          resumable.on('complete', () => {
            // All files uploaded
          });

          // Event: Error - catch-all error handler
          resumable.on('error', (message, file) => {
            // CRITICAL: Update queue item status BEFORE handling error
            const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
            if (queueItem && queueItem.status !== 'failed') {
              queueItem.status = 'failed';
              console.log('[MediaUpload] Queue item status updated to failed in error event:', uploadId);
            }
            
            // Extract error message
            let errorMessage = 'Upload failed. Please try again.';
            if (typeof message === 'string') {
              errorMessage = message;
            } else if (message && message.message) {
              errorMessage = message.message;
            }
            
            // Use centralized error handler
            handleUploadError(errorMessage);
            
            // CRITICAL: Remove from queue and process next IMMEDIATELY after error
            setTimeout(() => {
              console.log('[MediaUpload] Removing failed upload from queue (error event):', uploadId);
              vueInstance.removeUploadFromQueue(uploadId);
            }, 50);
          });

          // NOW add file to Resumable (this will trigger fileAdded event)
          const fileAdded = resumable.addFile(file.raw);
          
          // Check if file is actually in the array (more reliable than addFile return value)
          if (resumable.files.length === 0) {
            // File truly wasn't added - wait a bit to see if fileAdded event adds it
            setTimeout(() => {
              if (resumable.files.length === 0) {
                console.error('[MediaUpload] File was not added to Resumable after delay - check file type restrictions');
                
                // CRITICAL: Update queue item status BEFORE showing error
                const queueItem = vueInstance.uploadQueue.find(q => q.uploadId === uploadId);
                if (queueItem) {
                  queueItem.status = 'failed';
                  // console.log('[MediaUpload] Queue item status updated to failed (file not added):', uploadId);
                }
                
                if (progressNotification) {
                  progressNotification.close();
                }
                Notification({
                  message: `
                    <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                      <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                      Upload Failed
                    </p>
                    <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                      File could not be added for upload. Please check file type and size.
                    </p>
                  `,
                  duration: 5000,
                  dangerouslyUseHTMLString: true,
                });
                
                // CRITICAL: Remove from queue and process next IMMEDIATELY after error
                setTimeout(() => {
                  // console.log('[MediaUpload] Removing failed upload from queue (file not added):', uploadId);
                  vueInstance.removeUploadFromQueue(uploadId);
                }, 50);
              } else {
                console.log('[MediaUpload] File was added after delay via fileAdded event');
              }
            }, 200);
          } else {
            // If fileAdded event didn't fire automatically, manually start upload after a short delay
            setTimeout(() => {
              // CRITICAL: Don't start upload if already canceled
              if (uploadCanceled) {
                console.log('[MediaUpload] Manual upload start ignored - upload already canceled');
                // Clean up files
                if (resumable.files.length > 0) {
                  resumable.files.forEach(file => {
                    try {
                      resumable.removeFile(file);
                    } catch (e) {
                      console.warn('[MediaUpload] Error removing file:', e);
                    }
                  });
                }
                return;
              }
              
              if (resumable.files.length > 0 && !resumable.isUploading() && !uploadCanceled) {
                console.log('[MediaUpload] fileAdded event did not fire - manually starting upload');
                resumable.upload();
              }
            }, 100);
          }
        };
        
        // Store startUpload callback in queueItem
        queueItem.startUpload = startUpload;
        
        // Add to upload queue
        vueInstance.uploadQueue.push(queueItem);
        
        // Process queue (will start upload if slot available)
        vueInstance.processUploadQueue();
        
        // Start upload immediately if we have slot
        if (vueInstance.activeUploads.length < vueInstance.maxConcurrentUploads) {
          // This will be handled by processUploadQueue
          // But we can also start it directly here for immediate upload
          startUpload();
        } else {
          // Will be processed by processUploadQueue when slot available
          // startUpload callback is stored in queueItem
        }
      };

      // File types already detected above (isImage, isVideo, isZip)
      // Helper function to validate dimensions
      const validateDimensions = (width, height, fileType) => {
        if (this.localActiveDimensionFilter === 'available') {
          const isValid = this.allowedDims.some(d => d.w === width && d.h === height);
          if (!isValid) {
            loadingNotification.close();
            Notification({
              message: `
                <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                  <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                  Invalid Dimension
                </p>
                <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                  Invalid ${fileType} dimension ${width}x${height}.<br>
                  <span style="color: #909399; font-size: 13px;">Valid dimensions: ${this.allowedDims.map(d => d.w + "x" + d.h).join(", ")}</span>
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
            return false;
          }
        } else if (this.uploadTargetDim) {
          if (width !== this.uploadTargetDim.w || height !== this.uploadTargetDim.h) {
            loadingNotification.close();
            Notification({
              message: `
                <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                  <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                  Dimension Mismatch
                </p>
                <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                  ${fileType} must be exactly ${this.uploadTargetDim.w}x${this.uploadTargetDim.h}, but the selected file is ${width}x${height}.
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            });
            this.uploadTargetDim = null;
            return false;
          }
        }
        return true;
      };

      // Video dimension validation
      if (isVideo) {
        // Add timeout to prevent stuck when file is actually an image renamed to video
        const videoValidationTimeout = setTimeout(() => {
          loadingNotification.close();
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                Video Validation Timeout
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                The file appears to be invalid or corrupted. Please ensure you're uploading a valid video file.<br>
                <span style="color: #909399; font-size: 13px;">Note: Renaming image files to video extensions is not supported.</span>
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
          const idx = this.fileList.findIndex(f => f.uid === file.uid);
          if (idx !== -1) this.fileList.splice(idx, 1);
        }, 15000); // 15 second timeout for video (longer than image because video metadata takes more time)
        
        const video = document.createElement('video');
        video.preload = 'metadata';
        
        // Flag to prevent video.onerror from calling doUpload multiple times
        let videoErrorHandled = false;
        let videoMetadataHandled = false;
        
        // Video dimension requirements from Simpli.fi
        const VIDEO_MIN_WIDTH = 768;
        const VIDEO_MIN_HEIGHT = 576;
        const VIDEO_MAX_WIDTH = 1920;
        const VIDEO_MAX_HEIGHT = 1080;
        const VIDEO_PREFERRED_DIMENSIONS = [
          { w: 1920, h: 1080 },
          { w: 1920, h: 1200 }
        ];
        
        video.onloadedmetadata = () => {
          // Clear timeout since metadata loaded successfully
          clearTimeout(videoValidationTimeout);
          
          // Prevent multiple calls
          if (videoMetadataHandled) {
            return;
          }
          videoMetadataHandled = true;
          
          const width = video.videoWidth;
          const height = video.videoHeight;
          
          // console.log('[MediaUpload] Video dimensions:', { width, height });
          
          if (width > 0 && height > 0) {
            // Validate video dimensions according to Simpli.fi specs
            let isValid = true;
            let errorMessage = '';
            
            // Check minimum dimensions
            if (width < VIDEO_MIN_WIDTH || height < VIDEO_MIN_HEIGHT) {
              isValid = false;
              errorMessage = `Video dimensions ${width}x${height} are below the minimum requirement of ${VIDEO_MIN_WIDTH}x${VIDEO_MIN_HEIGHT}.`;
            }
            // Check maximum dimensions (optional, but recommended)
            // NOTE: This is just a warning, NOT an error - we allow videos larger than preferred
            if (width > VIDEO_MAX_WIDTH || height > VIDEO_MAX_HEIGHT) {
              // Warn but allow (some videos might be larger) - this is NOT an error
              console.warn('[MediaUpload] Video dimensions exceed preferred maximum:', { width, height, max: `${VIDEO_MAX_WIDTH}x${VIDEO_MAX_HEIGHT}` });
              // IMPORTANT: Do NOT set isValid = false here - we want to allow larger videos
              // isValid remains true, so upload will proceed
            }
            
            // Check aspect ratio (16:9 preferred, 4:3 not supported)
            const aspectRatio = width / height;
            const targetAspectRatio = 16 / 9;
            const aspectRatioDiff = Math.abs(aspectRatio - targetAspectRatio);
            
            if (aspectRatioDiff > 0.1) { // Allow small tolerance
              console.warn('[MediaUpload] Video aspect ratio is not 16:9:', { width, height, aspectRatio: aspectRatio.toFixed(2) });
              // Don't block, just warn
            }
            
            // IMPORTANT: isValid is only false if dimensions are BELOW minimum
            // If dimensions exceed preferred maximum, isValid remains true and upload proceeds
            if (isValid) {
              // Pass video dimensions to doUpload
              // console.log('[MediaUpload] Video validation passed, proceeding with upload:', { width, height, isValid });
              doUpload(width, height);
            } else {
              loadingNotification.close();
              Notification({
                message: `
                  <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                    <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                    Invalid Video Dimension
                  </p>
                  <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                    ${errorMessage}<br>
                    <span style="color: #909399; font-size: 13px;">Minimum: ${VIDEO_MIN_WIDTH}x${VIDEO_MIN_HEIGHT} | Preferred: 1920x1080 or 1920x1200</span>
                  </p>
                `,
                duration: 5000,
                dangerouslyUseHTMLString: true,
              });
              const idx = this.fileList.findIndex(f => f.uid === file.uid);
              if (idx !== -1) this.fileList.splice(idx, 1);
            }
          } else {
            // Video metadata loaded but dimensions are 0 or invalid
            // This might happen with some video formats. Don't show error, proceed with upload.
            // Backend will validate the file.
            console.warn('[MediaUpload] Video dimensions are 0 or invalid, proceeding with upload without dimension validation');
            
            // Clean up
            const videoSrc = video.src;
            video.src = '';
            if (videoSrc && videoSrc.startsWith('blob:')) {
              URL.revokeObjectURL(videoSrc);
            }
            
            // Proceed with upload without dimension validation
            doUpload(null, null);
          }
        };
        
        video.onerror = () => {
          // Clear timeout since error occurred
          clearTimeout(videoValidationTimeout);
          
          // CRITICAL: Prevent multiple calls to doUpload
          if (videoErrorHandled || videoMetadataHandled) {
            console.log('[MediaUpload] video.onerror ignored - already handled');
            return;
          }
          videoErrorHandled = true;
          
          // Check if file is actually an image renamed to video (using magic bytes)
          if (actualFileType === 'image') {
            loadingNotification.close();
            Notification({
              message: `
                <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                  <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                  Invalid Video File
                </p>
                <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                  The file could not be loaded as a video. This file is actually an image file that was renamed.<br>
                  <span style="color: #E6A23C; font-size: 13px; font-weight: 600;">⚠️ Renaming image files to video extensions is not supported.</span>
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
            
            // Clean up video element properly
            const videoSrc = video.src;
            video.src = '';
            video.onerror = null;
            video.onloadedmetadata = null;
            if (videoSrc && videoSrc.startsWith('blob:')) {
              URL.revokeObjectURL(videoSrc);
            }
            return;
          }
          
          // Some video formats (like MOV) may not be readable by browser for metadata
          // but the file is still valid. Don't show error, just proceed with upload.
          // Backend will handle the file validation.
          console.warn('[MediaUpload] Could not read video metadata (browser limitation), proceeding with upload');
          
          // Clean up video element properly
          const videoSrc = video.src;
          video.src = '';
          video.onerror = null; // Remove error handler to prevent further calls
          video.onloadedmetadata = null; // Remove metadata handler to prevent further calls
          if (videoSrc && videoSrc.startsWith('blob:')) {
            URL.revokeObjectURL(videoSrc);
          }
          
          // Proceed with upload without dimension validation
          // Don't close loadingNotification, let doUpload handle it
          doUpload(null, null);
        };
        
        video.src = URL.createObjectURL(file.raw);
        return;
      }

      // HTML5 ZIP files - basic validation in frontend
      if (isZip) {
        // console.log('[MediaUpload] HTML5 ZIP file detected');
        
        // Basic validation: File size (max 10 MB for HTML5)
        const maxSizeBytes = 10 * 1024 * 1024; // 10 MB
        if (file.raw.size > maxSizeBytes) {
          loadingNotification.close();
          const fileSizeMB = (file.raw.size / (1024 * 1024)).toFixed(2);
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                File Too Large
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                HTML5 ZIP file size (${fileSizeMB} MB) exceeds the maximum limit of 10 MB.
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
          const idx = this.fileList.findIndex(f => f.uid === file.uid);
          if (idx !== -1) this.fileList.splice(idx, 1);
          return;
        }
        
        // Basic validation: File name should end with .zip
        const fileName = file.raw.name.toLowerCase();
        if (!fileName.endsWith('.zip')) {
          loadingNotification.close();
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                Invalid File Type
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                HTML5 files must be in ZIP format (.zip extension).
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
          const idx = this.fileList.findIndex(f => f.uid === file.uid);
          if (idx !== -1) this.fileList.splice(idx, 1);
          return;
        }
        
        // console.log('[MediaUpload] HTML5 ZIP file passed basic validation, uploading for backend dimension extraction and validation');
        doUpload();
        return;
      }

      // Image dimension validation (existing flow)
      if (isImage) {
        // Add timeout to prevent stuck when file is actually a video renamed to image
        const validationTimeout = setTimeout(() => {
          loadingNotification.close();
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                File Validation Timeout
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                The file appears to be invalid or corrupted. Please ensure you're uploading a valid image file.<br>
                <span style="color: #909399; font-size: 13px;">Note: Renaming video files to image extensions is not supported.</span>
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
          const idx = this.fileList.findIndex(f => f.uid === file.uid);
          if (idx !== -1) this.fileList.splice(idx, 1);
        }, 10000); // 10 second timeout
        
        const reader = new FileReader();
        reader.onload = (e) => {
          clearTimeout(validationTimeout);
          const img = new Image();
          
          // Add error handler for invalid image files
          img.onerror = () => {
            clearTimeout(validationTimeout);
            loadingNotification.close();
            Notification({
              message: `
                <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                  <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                  Invalid Image File
                </p>
                <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                  The file could not be loaded as an image. Please ensure you're uploading a valid image file.<br>
                  <span style="color: #909399; font-size: 13px;">Note: Renaming video files to image extensions is not supported.</span>
                </p>
              `,
              duration: 5000,
              dangerouslyUseHTMLString: true,
            });
            const idx = this.fileList.findIndex(f => f.uid === file.uid);
            if (idx !== -1) this.fileList.splice(idx, 1);
          };
          
          img.onload = () => {
            clearTimeout(validationTimeout);
            const width = img.width;
            const height = img.height;

            if (validateDimensions(width, height, 'Image')) {
              // If all good, upload image
              doUpload();
            }
          };
          img.src = e.target.result;
        };
        
        reader.onerror = () => {
          clearTimeout(validationTimeout);
          loadingNotification.close();
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                File Read Error
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                Failed to read the file. Please try again or upload a different file.
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
          const idx = this.fileList.findIndex(f => f.uid === file.uid);
          if (idx !== -1) this.fileList.splice(idx, 1);
        };
        
        reader.readAsDataURL(file.raw);
        return;
      }

      // If file type is unknown, proceed with upload
      doUpload();
    },
    async handleDelete() {
      if (!this.selectedItems.length || this.isDeletingMedia) return;
      const selectedIds = this.selectedItems.map(item => item.id);
      
      // Show confirmation dialog
      try {
        await MessageBox.confirm(
          `Are you sure you want to delete ${selectedIds.length} selected media file(s)? This action cannot be undone.`,
          'Delete Media Files?',
          {
            confirmButtonText: 'Delete',
            cancelButtonText: 'Cancel',
            type: 'warning',
            distinguishCancelAndClose: true
          }
        );
      } catch (error) {
        // User cancelled or closed the dialog
        return;
      }
      
      this.deleteOperationInProgress = true;
      this.deletingIds = [...this.deletingIds, ...selectedIds];
      try {
        // Send as JSON array - Laravel will accept this format
        await axios.post(`${process.env.VUE_APP_DATASERVER_URL}/api/media/delete`, {
          media_ids: selectedIds
        }, {
          headers: {
            'Content-Type': 'application/json'
          }
        });
        await this.getMedia();
        this.selectedItems = this.selectedItems.filter(item => !selectedIds.includes(item.id));
        Notification({
          message: `
            <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
              <i class="el-icon-success" style="margin-right: 10px; font-size: 18px; color: #67C23A;"></i>
              Success
            </p>
            <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
              Selected media deleted successfully!
            </p>
          `,
          duration: 3000,
          dangerouslyUseHTMLString: true,
        });
      } catch (error) {
        const message = (error.response && error.response.data && error.response.data.message) || 'Failed to delete media.';
        const campaignIds = (error.response && error.response.data && error.response.data.campaign_ids) || [];
        
        let notificationMessage = `
          <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
            <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
            Delete Failed
          </p>
          <p style="color: #606266; font-size: 14px; margin: 0 0 8px 0; line-height: 1.6;">
            ${message}
          </p>
        `;
        
        if (campaignIds.length > 0) {
          const campaignList = campaignIds.map(id => `<span style="display: inline-block; background: #FEF0F0; color: #F56C6C; padding: 2px 8px; border-radius: 4px; margin: 2px; font-size: 12px; font-weight: 500;">${id}</span>`).join('');
          notificationMessage += `
            <p style="color: #606266; font-size: 13px; margin: 8px 0 0 0; font-weight: 500;">
              Campaign IDs using this media:
            </p>
            <div style="margin-top: 8px; line-height: 1.8;">
              ${campaignList}
            </div>
            <p style="color: #909399; font-size: 12px; margin: 8px 0 0 0; line-height: 1.5;">
              Please remove the media from these campaigns first before deleting.
            </p>
          `;
        }
        
        Notification({
          message: notificationMessage,
          duration: 8000,
          dangerouslyUseHTMLString: true,
        });
      } finally {
        this.deletingIds = this.deletingIds.filter(id => !selectedIds.includes(id));
        this.deleteOperationInProgress = false;
      }
    },
    getSelectableMediaItems() {
      const availableIds = new Set(this.mediaData.map(item => Number(item.id)));
      return this.selectedItems.filter(
        item => !this.deletingIds.includes(item.id) && availableIds.has(Number(item.id))
      );
    },
    notifyMediaActionBlocked(message) {
      Notification({
        message: `
          <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
            <i class="el-icon-warning" style="margin-right: 10px; font-size: 18px; color: #E6A23C;"></i>
            Please wait
          </p>
          <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
            ${message}
          </p>
        `,
        duration: 4000,
        dangerouslyUseHTMLString: true,
      });
    },
    async downloadSelected() {
        if (!this.selectedItems.length || this.isDeletingMedia) return;

        // Calculate total size of selected files
        const MAX_DOWNLOAD_SIZE = 200 * 1024 * 1024; // 200 MB in bytes
        const totalSize = this.selectedItems.reduce((sum, item) => {
            // size is in bytes from backend
            return sum + (parseInt(item.size) || 0);
        }, 0);

        // Format bytes to MB for display
        const formatBytes = (bytes) => {
            if (bytes === 0) return '0 Bytes';
            const k = 1024;
            const sizes = ['Bytes', 'KB', 'MB', 'GB'];
            const i = Math.floor(Math.log(bytes) / Math.log(k));
            return Math.round((bytes / Math.pow(k, i)) * 100) / 100 + ' ' + sizes[i];
        };
        
        // Validate total size
        if (totalSize > MAX_DOWNLOAD_SIZE) {
            const totalSizeMB = (totalSize / (1024 * 1024)).toFixed(2);
            Notification({
                message: `
                    <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                        <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                        Download Size Limit Exceeded
                    </p>
                    <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                        Total size of selected files (${totalSizeMB} MB) exceeds the maximum download limit of 200 MB.<br>
                        <span style="color: #909399; font-size: 13px;">Please select fewer files or files with smaller sizes.</span>
                    </p>
                `,
                duration: 5000,
                dangerouslyUseHTMLString: true,
            });
            return;
        }

        const media_ids = this.selectedItems.map(item => item.id);
        const payload = { data: { media_ids } };
        const response = await this.GetDownloadMediaToken(payload);
        if (response.token) {
          try {
              const url = `${process.env.VUE_APP_DATASERVER_URL}/download-media/${response.token}`;
              const fileName = this.selectedItems.length === 1 
                  ? this.selectedItems[0].name
                  : 'selected-files.zip';
              downloadMediaBackground(url, fileName);
          } catch (err) {
              console.error("Failed to download:", err);
          }
        } else {
          Notification({
            message: `
              <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
                <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
                Download Failed
              </p>
              <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
                Failed to get download token.
              </p>
            `,
            duration: 5000,
            dangerouslyUseHTMLString: true,
          });
        }
    },
    downloadHtml5Example() {
      const exampleUrl = 'https://emmspaces.nyc3.cdn.digitaloceanspaces.com/users/media/html5/ads_html5_example.zip';
      // Open URL in new tab to avoid CORS issues
      window.open(exampleUrl, '_blank');
    },
    selectItem(item) {
      if (this.isDeletingMedia || this.deletingIds.includes(item.id)) return;
      const index = this.selectedItems.findIndex(i => i.id === item.id);
      (index !== -1) ? this.selectedItems.splice(index, 1) : this.selectedItems.push(item);
    },
    addToCampaign(){
      if (this.isDeletingMedia) {
        this.notifyMediaActionBlocked('Media is still being deleted. Wait until deletion finishes before adding media to your campaign.');
        return;
      }
      if (this.isLoadingMedia) {
        this.notifyMediaActionBlocked('Media list is still loading. Please try again in a moment.');
        return;
      }
      const validItems = this.getSelectableMediaItems();
      if (!validItems.length) {
        Notification({
          message: `
            <p style="display: flex; align-items: center; color: #303133; font-size: 16px; font-weight: 600; margin: 0 0 8px 0;">
              <i class="el-icon-error" style="margin-right: 10px; font-size: 18px; color: #F56C6C;"></i>
              Cannot add media
            </p>
            <p style="color: #606266; font-size: 14px; margin: 0; line-height: 1.6;">
              Selected file(s) are no longer available. Please select media again.
            </p>
          `,
          duration: 4000,
          dangerouslyUseHTMLString: true,
        });
        this.selectedItems = [];
        return;
      }
      if (validItems.length < this.selectedItems.length) {
        this.selectedItems = validItems;
      }
      this.$emit('selected-media', validItems);
    },
    openPreview(item) {
      // console.log('openPreview', item);
      
      this.previewItem = item;
      this.html5PreviewBlobUrl = null;
      this.html5PreviewLoading = false;
      this.html5PreviewError = null;
      
      // Check if HTML5 by detecting ad file type directly
      const adFileTypeId = this.detectAdFileType(item);
      if (adFileTypeId === 9 && item.media) {
        // HTML5 ZIP file - load and extract
        this.loadHtml5Preview(item.media);
      }
      
      this.previewOpen = true;
    },
    /**
     * Load JSZip library from CDN (only once)
     */
    async loadJSZip() {
      // Check if JSZip is already loaded
      if (window.JSZip) {
        return window.JSZip;
      }
      
      // Check if script is already being loaded
      if (this.jsZipLoadingPromise) {
        return this.jsZipLoadingPromise;
      }
      
      // Load JSZip from CDN (library stays in frontend)
      this.jsZipLoadingPromise = new Promise((resolve, reject) => {
        const script = document.createElement('script');
        script.src = 'https://cdnjs.cloudflare.com/ajax/libs/jszip/3.10.1/jszip.min.js';
        script.integrity = 'sha512-XMVd28F1oH/O71fzwBnV7HucLxVwtxf26XV8P4wPk26EDxuGZ91N8bsOttmnomcCD3CS5ZMRL50H0GgOHvegtg==';
        script.crossOrigin = 'anonymous';
        script.referrerPolicy = 'no-referrer';
        
        script.onload = () => {
          // console.log('[HTML5 Preview] JSZip loaded successfully');
          resolve(window.JSZip);
        };
        
        script.onerror = (error) => {
          console.error('[HTML5 Preview] Failed to load JSZip:', error);
          this.jsZipLoadingPromise = null;
          reject(new Error('Failed to load JSZip library'));
        };
        
        document.head.appendChild(script);
      });
      
      return this.jsZipLoadingPromise;
    },
    /**
     * Load and extract HTML5 ZIP file for preview
     */
    async loadHtml5Preview(zipUrl) {
      this.html5PreviewLoading = true;
      this.html5PreviewError = null;
      this.html5PreviewBlobUrl = null;
      
      try {
        // Step 1: Load JSZip library
        const JSZip = await this.loadJSZip();
        
        // Step 2: Fetch ZIP file through backend proxy to avoid CORS
        // console.log('[HTML5 Preview] Fetching ZIP file through backend proxy:', zipUrl);
        
        // Get auth token for axios request
        const token = localStorage.getItem('access_token');
        const baseURL = axios.defaults.baseURL || '/api';
        const proxyUrl = `${baseURL}/media/proxy-zip?url=${encodeURIComponent(zipUrl)}`;
        
        const response = await axios.get(proxyUrl, {
          responseType: 'arraybuffer',
          headers: {
            'Authorization': `Bearer ${token}`,
            'Accept': 'application/zip, application/octet-stream, */*'
          }
        });
        
        // Step 3: Get ZIP as ArrayBuffer
        const zipArrayBuffer = response.data;
        // console.log('[HTML5 Preview] ZIP file downloaded, size:', zipArrayBuffer.byteLength, 'bytes');
        
        // Step 4: Extract ZIP
        const zip = await JSZip.loadAsync(zipArrayBuffer);
        // console.log('[HTML5 Preview] ZIP extracted, files:', Object.keys(zip.files).length);
        
        // Step 5: Find index.html (case-insensitive)
        let indexHtmlEntry = null;
        let indexHtmlPath = null;
        
        for (const [path, entry] of Object.entries(zip.files)) {
          if (!entry.dir && entry.name.toLowerCase().endsWith('index.html')) {
            indexHtmlEntry = entry;
            indexHtmlPath = path;
            break;
          }
        }
        
        if (!indexHtmlEntry) {
          throw new Error('index.html not found in ZIP file');
        }
        
        // console.log('[HTML5 Preview] Found index.html at:', indexHtmlPath);
        
        // Step 6: Read index.html content
        const htmlContent = await indexHtmlEntry.async('string');
        
        // Step 7: Replace {{clickMacro}} with # for preview and disable all clicks/redirects
        let processedHtml = htmlContent
          .replace(/\{\{clickMacro\}\}/g, '#')
          .replace(/\{\{\s*clickMacro\s*\}\}/g, '#');
        
        // Inject script to prevent all clicks and redirects in preview
        // Using string concatenation and escaping script tag to avoid Vue parser issues
        const scriptStart = '<scr' + 'ipt>';
        const scriptEnd = '</scr' + 'ipt>';
        const preventClickScript = scriptStart +
          '(function() {' +
          'document.addEventListener("click", function(e) { e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation(); return false; }, true);' +
          'window.open = function() { return null; };' +
          'try { Object.defineProperty(window, "location", { get: function() { return window.location; }, set: function() { return false; } }); } catch(e) {}' +
          'document.addEventListener("submit", function(e) { e.preventDefault(); e.stopPropagation(); return false; }, true);' +
          'document.addEventListener("DOMContentLoaded", function() {' +
          'var links = document.querySelectorAll("a");' +
          'for (var i = 0; i < links.length; i++) {' +
          'links[i].href = "#";' +
          'links[i].onclick = function(e) { e.preventDefault(); e.stopPropagation(); return false; };' +
          'links[i].addEventListener("click", function(e) { e.preventDefault(); e.stopPropagation(); return false; }, true);' +
          '}' +
          '});' +
          '})();' +
          scriptEnd;
        
        // Insert script before closing </body> tag, or before closing </head> if no body
        if (processedHtml.includes('</body>')) {
          processedHtml = processedHtml.replace('</body>', preventClickScript + '</body>');
        } else if (processedHtml.includes('</head>')) {
          processedHtml = processedHtml.replace('</head>', preventClickScript + '</head>');
        } else {
          // If no body or head tag, append to end
          processedHtml += preventClickScript;
        }
        
        // Step 8: Create Blob URLs for all assets and replace paths in HTML
        const blobUrls = new Map(); // Store blob URLs for cleanup
        const basePath = indexHtmlPath.substring(0, indexHtmlPath.lastIndexOf('/') + 1);
        
        // Find all asset paths in HTML (href and src attributes)
        const assetPathRegex = /(href|src)=["']([^"']+)["']/gi;
        const assetPaths = [];
        let match;
        
        while ((match = assetPathRegex.exec(processedHtml)) !== null) {
          const attr = match[1];
          const path = match[2];
          
          // Skip absolute URLs, data URIs, and anchor links
          if (/^(https?:\/\/|data:|#|mailto:)/i.test(path)) {
            continue;
          }
          
          // Skip if path starts with / (absolute path from root)
          if (path.startsWith('/')) {
            continue;
          }
          
          assetPaths.push({ attr, path, fullMatch: match[0] });
        }
        
        // Process all assets and create Blob URLs
        const assetReplacements = new Map();
        
        for (const { attr, path, fullMatch } of assetPaths) {
          // Resolve relative path
          let assetPath = path;
          if (!path.startsWith(basePath)) {
            assetPath = basePath + path;
          }
          
          // Normalize path (handle ./ and ../)
          const pathParts = assetPath.split('/');
          const normalizedParts = [];
          for (const part of pathParts) {
            if (part === '.' || part === '') {
              continue;
            } else if (part === '..') {
              normalizedParts.pop();
            } else {
              normalizedParts.push(part);
            }
          }
          assetPath = normalizedParts.join('/');
          
          // Try to find asset in ZIP (with and without leading slash)
          const assetEntry = zip.files[assetPath] || zip.files['/' + assetPath] || zip.files[assetPath.replace(/^\//, '')];
          
          if (assetEntry && !assetEntry.dir) {
            try {
              // Get asset content as Blob
              const assetBlob = await assetEntry.async('blob');
              const mimeType = this.getMimeTypeFromPath(assetPath);
              const blobUrl = URL.createObjectURL(new Blob([assetBlob], { type: mimeType }));
              
              // Store blob URL for cleanup
              blobUrls.set(assetPath, blobUrl);
              
              // Store replacement
              assetReplacements.set(fullMatch, `${attr}="${blobUrl}"`);
            } catch (error) {
              console.warn('[HTML5 Preview] Failed to create blob URL for asset:', assetPath, error);
            }
          }
        }
        
        // Replace all asset paths with Blob URLs
        assetReplacements.forEach((replacement, original) => {
          processedHtml = processedHtml.replace(original, replacement);
        });
        
        // Step 8.5: Process CSS url() references (for background-image, etc.)
        // This handles images referenced in CSS that won't be caught by href/src regex
        const cssUrlRegex = /url\s*\(\s*["']?([^"')]+)["']?\s*\)/gi;
        const cssReplacements = new Map();
        
        // Process inline CSS in <style> tags
        const styleTagRegex = /<style[^>]*>([\s\S]*?)<\/style>/gi;
        let styleMatch;
        
        while ((styleMatch = styleTagRegex.exec(processedHtml)) !== null) {
          const styleContent = styleMatch[1];
          const fullStyleTag = styleMatch[0];
          let updatedStyleContent = styleContent;
          let cssMatch;
          
          // Reset regex lastIndex for each style tag
          cssUrlRegex.lastIndex = 0;
          
          while ((cssMatch = cssUrlRegex.exec(styleContent)) !== null) {
            const cssPath = cssMatch[1].trim();
            
            // Skip absolute URLs, data URIs
            if (/^(https?:\/\/|data:|#)/i.test(cssPath)) {
              continue;
            }
            
            // Skip if path starts with / (absolute path from root)
            if (cssPath.startsWith('/')) {
              continue;
            }
            
            // Resolve relative path
            let assetPath = cssPath;
            if (!cssPath.startsWith(basePath)) {
              assetPath = basePath + cssPath;
            }
            
            // Normalize path (handle ./ and ../)
            const pathParts = assetPath.split('/');
            const normalizedParts = [];
            for (const part of pathParts) {
              if (part === '.' || part === '') {
                continue;
              } else if (part === '..') {
                normalizedParts.pop();
              } else {
                normalizedParts.push(part);
              }
            }
            assetPath = normalizedParts.join('/');
            
            // Try to find asset in ZIP
            const assetEntry = zip.files[assetPath] || zip.files['/' + assetPath] || zip.files[assetPath.replace(/^\//, '')];
            
            if (assetEntry && !assetEntry.dir) {
              try {
                // Check if we already created a blob URL for this asset
                let blobUrl = blobUrls.get(assetPath);
                
                if (!blobUrl) {
                  // Get asset content as Blob
                  const assetBlob = await assetEntry.async('blob');
                  const mimeType = this.getMimeTypeFromPath(assetPath);
                  blobUrl = URL.createObjectURL(new Blob([assetBlob], { type: mimeType }));
                  
                  // Store blob URL for cleanup
                  blobUrls.set(assetPath, blobUrl);
                }
                
                // Replace url() reference with blob URL
                const originalUrl = cssMatch[0];
                const newUrl = `url("${blobUrl}")`;
                updatedStyleContent = updatedStyleContent.replace(originalUrl, newUrl);
              } catch (error) {
                console.warn('[HTML5 Preview] Failed to create blob URL for CSS asset:', assetPath, error);
              }
            }
          }
          
          // Replace the style tag content if it was modified
          if (updatedStyleContent !== styleContent) {
            const updatedStyleTag = fullStyleTag.replace(styleContent, updatedStyleContent);
            cssReplacements.set(fullStyleTag, updatedStyleTag);
          }
        }
        
        // Process external CSS files referenced in <link> tags
        const linkCssRegex = /<link[^>]*href=["']([^"']+\.css[^"']*)["'][^>]*>/gi;
        let linkMatch;
        const cssFilesToProcess = [];
        
        while ((linkMatch = linkCssRegex.exec(processedHtml)) !== null) {
          const cssPath = linkMatch[1];
          
          // Skip absolute URLs
          if (/^(https?:\/\/|data:)/i.test(cssPath)) {
            continue;
          }
          
          // Resolve relative path
          let assetPath = cssPath;
          if (!cssPath.startsWith(basePath)) {
            assetPath = basePath + cssPath;
          }
          
          // Normalize path
          const pathParts = assetPath.split('/');
          const normalizedParts = [];
          for (const part of pathParts) {
            if (part === '.' || part === '') {
              continue;
            } else if (part === '..') {
              normalizedParts.pop();
            } else {
              normalizedParts.push(part);
            }
          }
          assetPath = normalizedParts.join('/');
          
          cssFilesToProcess.push({ linkTag: linkMatch[0], assetPath });
        }
        
        // Process each external CSS file
        for (const { linkTag, assetPath } of cssFilesToProcess) {
          const cssEntry = zip.files[assetPath] || zip.files['/' + assetPath] || zip.files[assetPath.replace(/^\//, '')];
          
          if (cssEntry && !cssEntry.dir) {
            try {
              let cssContent = await cssEntry.async('string');
              let cssUpdated = false;
              let cssUrlMatch;
              
              // Reset regex lastIndex
              cssUrlRegex.lastIndex = 0;
              
              while ((cssUrlMatch = cssUrlRegex.exec(cssContent)) !== null) {
                const cssPath = cssUrlMatch[1].trim();
                
                // Skip absolute URLs, data URIs
                if (/^(https?:\/\/|data:|#)/i.test(cssPath)) {
                  continue;
                }
                
                // Skip if path starts with /
                if (cssPath.startsWith('/')) {
                  continue;
                }
                
                // Resolve relative path from CSS file location
                const cssBasePath = assetPath.substring(0, assetPath.lastIndexOf('/') + 1);
                let relativeAssetPath = cssPath;
                if (!cssPath.startsWith(cssBasePath)) {
                  relativeAssetPath = cssBasePath + cssPath;
                }
                
                // Normalize path
                const pathParts = relativeAssetPath.split('/');
                const normalizedParts = [];
                for (const part of pathParts) {
                  if (part === '.' || part === '') {
                    continue;
                  } else if (part === '..') {
                    normalizedParts.pop();
                  } else {
                    normalizedParts.push(part);
                  }
                }
                const normalizedAssetPath = normalizedParts.join('/');
                
                // Try to find asset in ZIP
                const assetEntry = zip.files[normalizedAssetPath] || zip.files['/' + normalizedAssetPath] || zip.files[normalizedAssetPath.replace(/^\//, '')];
                
                if (assetEntry && !assetEntry.dir) {
                  // Check if we already created a blob URL for this asset
                  let blobUrl = blobUrls.get(normalizedAssetPath);
                  
                  if (!blobUrl) {
                    // Get asset content as Blob
                    const assetBlob = await assetEntry.async('blob');
                    const mimeType = this.getMimeTypeFromPath(normalizedAssetPath);
                    blobUrl = URL.createObjectURL(new Blob([assetBlob], { type: mimeType }));
                    
                    // Store blob URL for cleanup
                    blobUrls.set(normalizedAssetPath, blobUrl);
                  }
                  
                  // Replace url() reference with blob URL
                  const originalUrl = cssUrlMatch[0];
                  const newUrl = `url("${blobUrl}")`;
                  cssContent = cssContent.replace(originalUrl, newUrl);
                  cssUpdated = true;
                }
              }
              
              // If CSS was updated, create inline style tag instead of link tag
              if (cssUpdated) {
                const inlineStyleTag = `<style>${cssContent}</style>`;
                cssReplacements.set(linkTag, inlineStyleTag);
              }
            } catch (error) {
              console.warn('[HTML5 Preview] Failed to process external CSS file:', assetPath, error);
            }
          }
        }
        
        // Replace all CSS-related content
        cssReplacements.forEach((replacement, original) => {
          processedHtml = processedHtml.replace(original, replacement);
        });
        
        // Step 9: Create Blob URL for processed HTML
        const htmlBlob = new Blob([processedHtml], { type: 'text/html' });
        const htmlBlobUrl = URL.createObjectURL(htmlBlob);
        
        // Store blob URLs for cleanup when dialog closes
        this.html5PreviewBlobUrls = blobUrls;
        this.html5PreviewBlobUrls.set('index.html', htmlBlobUrl);
        
        this.html5PreviewBlobUrl = htmlBlobUrl;
        this.html5PreviewLoading = false;
        
        // console.log('[HTML5 Preview] HTML5 preview loaded successfully');
        
      } catch (error) {
        console.error('[HTML5 Preview] Error loading HTML5 preview:', error);
        this.html5PreviewError = error.message || 'Failed to load HTML5 preview. Please try again.';
        this.html5PreviewLoading = false;
        
        // Cleanup on error
        if (this.html5PreviewBlobUrls) {
          this.cleanupHtml5Preview();
        }
      }
    },
    /**
     * Get MIME type from file path/extension
     */
    getMimeTypeFromPath(path) {
      const extension = path.split('.').pop().toLowerCase();
      const mimeTypes = {
        'css': 'text/css',
        'js': 'application/javascript',
        'jpg': 'image/jpeg',
        'jpeg': 'image/jpeg',
        'png': 'image/png',
        'gif': 'image/gif',
        'svg': 'image/svg+xml',
        'woff': 'font/woff',
        'woff2': 'font/woff2',
        'ttf': 'font/ttf',
        'eot': 'application/vnd.ms-fontobject',
        'html': 'text/html',
        'htm': 'text/html',
      };
      return mimeTypes[extension] || 'application/octet-stream';
    },
    /**
     * Handle preview dialog close event
     * Pauses video and cleans up resources
     */
    handlePreviewDialogClose() {
      // Pause video when dialog closes
      this.$nextTick(() => {
        if (this.$refs.previewVideo) {
          const video = this.$refs.previewVideo;
          if (video && typeof video.pause === 'function') {
            video.pause();
            // Reset video to beginning
            video.currentTime = 0;
          }
        }
      });
      
      // Cleanup HTML5 preview
      this.cleanupHtml5Preview();
    },
    /**
     * Cleanup Blob URLs when preview dialog closes
     */
    disableHtml5PreviewClicks() {
      // Additional protection: prevent navigation in iframe
      try {
        const iframe = this.$refs.html5PreviewIframe;
        if (iframe && iframe.contentWindow) {
          // Override window.open in iframe
          iframe.contentWindow.open = function() {
            return null;
          };
          
          // Prevent location changes
          try {
            Object.defineProperty(iframe.contentWindow, 'location', {
              get: function() {
                return iframe.contentWindow.location;
              },
              set: function() {
                return false;
              }
            });
          } catch (e) {
            // Some browsers may not allow this, that's okay
            console.warn('[HTML5 Preview] Could not override location property:', e);
          }
        }
      } catch (error) {
        // Cross-origin restrictions may prevent access, that's okay
        // The injected script should handle it
        console.warn('[HTML5 Preview] Could not access iframe content:', error);
      }
    },
    cleanupHtml5Preview() {
      if (this.html5PreviewBlobUrls) {
        this.html5PreviewBlobUrls.forEach((blobUrl) => {
          URL.revokeObjectURL(blobUrl);
        });
        this.html5PreviewBlobUrls = null;
      }
      if (this.html5PreviewBlobUrl) {
        URL.revokeObjectURL(this.html5PreviewBlobUrl);
        this.html5PreviewBlobUrl = null;
      }
    },
  },
};
</script>

<style lang="scss">
// Notification styling improvements
::v-deep .el-notification {
  box-shadow: 0 2px 12px 0 rgba(0, 0, 0, 0.1) !important;
  border-radius: 4px !important;
  padding: 14px 19px !important;
  min-width: 330px !important;
  max-width: 450px !important;
  border-left: 4px solid transparent !important;
  background-color: #fff !important;
  
  // Success notification
  &.el-notification--success {
    border-left-color: #67C23A !important;
  }
  
  // Error notification
  &.el-notification--error {
    border-left-color: #F56C6C !important;
  }
  
  // Warning notification
  &.el-notification--warning {
    border-left-color: #E6A23C !important;
  }
  
  // Info notification
  &.el-notification--info {
    border-left-color: #909399 !important;
  }
  
  .el-notification__title {
    color: #303133 !important;
    font-weight: 500 !important;
    font-size: 16px !important;
    line-height: 24px !important;
    margin-bottom: 0 !important;
    padding: 0 !important;
  }
  
  .el-notification__content {
    margin-top: 6px !important;
    padding: 0 !important;
    
    p {
      color: #606266 !important;
      font-size: 14px !important;
      line-height: 22px !important;
      margin: 0 !important;
      word-wrap: break-word !important;
      padding: 0 !important;
      
      &:first-child {
        color: #303133 !important;
        font-weight: 500 !important;
        font-size: 16px !important;
        line-height: 24px !important;
        margin-bottom: 6px !important;
        display: flex !important;
        align-items: center !important;
        padding: 0 !important;
        
        i {
          margin-right: 8px !important;
          font-size: 18px !important;
          flex-shrink: 0 !important;
        }
      }
      
      &:not(:first-child) {
        margin-top: 4px !important;
        color: #606266 !important;
        font-size: 14px !important;
        line-height: 22px !important;
        padding: 0 !important;
        
        span {
          display: inline-block !important;
        }
      }
    }
  }
  
  .el-notification__icon {
    font-size: 18px !important;
    margin-right: 8px !important;
    flex-shrink: 0 !important;
  }
  
  .el-notification__closeBtn {
    color: #C0C4CC !important;
    font-size: 16px !important;
    top: 14px !important;
    right: 14px !important;
    transition: color 0.3s !important;
    
    &:hover {
      color: #909399 !important;
    }
  }
  
  // Ensure proper spacing between notifications
  & + .el-notification {
    margin-top: 16px !important;
  }
}

// Prevent notification overlap - ensure proper spacing
::v-deep .el-notification-group {
  .el-notification {
    margin-bottom: 16px !important;
  }
}

// Animation for loading icon
@keyframes rotating {
  from {
    transform: rotate(0deg);
  }
  to {
    transform: rotate(360deg);
  }
}

.media-preview-dialog {
  .el-message-box__content { padding: 0 0 12px; }
  .el-message-box__headerbtn { top: 8px; right: 8px; }
}

.media-image-preview {
  .el-dialog__title {
    color: #111827 !important;
    font-weight: 700 !important;
    letter-spacing: .2px;
  }
  .el-dialog__header { color: #111827 !important; }
}
.audiance-upload .el-upload-dragger {
  width: 100%;
}

.audiance-upload .el-upload {
  width: 100%;
}

.media-collection-wrapper {
  max-height: 490px;
  overflow-y: auto;
  padding: 0 15px 15px;
}

// .media-collection-grid {
//   display: grid;
//   margin-top: 16px;
//   position: unset !important;
//   gap: 1.5rem;
//   grid-template-columns: repeat(4, minmax(0, 1fr));
// }

.rounded-lg {
  border-radius: 0.5rem;
}

.audiance-upload .el-upload { width: 100%; }
+
.media-dimension-group {
  margin-bottom: 40px;
}

.dimension-title {
  position: relative;
  background: transparent;
  padding: 0;
  margin: 8px 0 12px;
  display: flex;
  flex-direction: column;
  gap: 6px;

  .dimension-row {
    display: inline-flex;
    align-items: baseline;
    gap: 8px;
  }

  .dimension-label {
    font-weight: 700;
    font-size: 14px;
    color: #1f2937; /* gray-800 */
  }

  .dimension-count {
    font-size: 12px;
    color: #6b7280; /* gray-500 */
    margin-left: 0;
  }

  // dotted divider below the label row
  .dimension-divider {
    width: 100%;
    height: 0;
    border-bottom: 1px dotted #d1d5db; /* gray-300 */
  }
}

.media-collection-grid {
  display: grid;
  grid-template-columns: repeat(auto-fill, minmax(150px, 1fr));
  gap: 20px;
}

.media-box {
  width: 100%;
  aspect-ratio: 1 / 1;    /* Selalu kotak */
  border-radius: 8px;
  overflow: hidden;
  display: flex;
  align-items: center;
  justify-content: center;
  flex-direction: column;
}

.placeholder {
  background: linear-gradient(135deg, #f5f7fa 0%, #e9eef5 100%);
  color: #666;
  cursor: pointer;
  transition: all 0.2s ease;
  border: 2px dashed #c5d1e0;
  gap: 8px;
}

.placeholder:hover {
  background: linear-gradient(135deg, #edf5ff 0%, #e3ecf7 100%);
  border-color: #6aa3ff;
  color: #2a6bf4;
  transform: translateY(-2px);
}

.placeholder--disabled {
  opacity: 0.5;
  cursor: not-allowed;
  pointer-events: none;
}

.placeholder--disabled:hover {
  transform: none;
  border-color: #c5d1e0;
  color: #666;
  background: linear-gradient(135deg, #f5f7fa 0%, #e9eef5 100%);
}

.placeholder i {
  font-size: 24px;
}

.placeholder .placeholder-label {
  font-size: 12px;
  font-weight: 600;
}

.state-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  height: 300px;
  color: #909399;
  text-align: center;
  
  i {
    font-size: 48px;
    margin-bottom: 16px;
  }

  span {
    font-size: 14px;
  }
}

// Recommended Sizes Section Styles
.recommended-sizes-section {
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  padding: 16px 20px;
  margin-bottom: 16px;
}

.recommended-sizes-header {
  display: flex;
  align-items: center;
  margin-bottom: 8px;
}

.recommended-sizes-title {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

.recommended-sizes-description {
  margin-bottom: 12px;
}

.recommended-sizes-description span {
  font-size: 12px;
  color: #64748b;
  font-style: italic;
}

.recommended-sizes-grid {
  display: flex;
  flex-wrap: wrap;
  gap: 8px;
}

.size-badge {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  padding: 3px 6px;
  font-size: 11px;
  font-weight: 400;
  color: #64748b;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  cursor: default;
  user-select: none;
}

// HTML5 Specification Styles
.html5-spec-container {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.04);
  overflow: hidden;
  transition: all 0.3s ease;
}

.html5-spec-container:hover {
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.08);
}

.html5-spec-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 16px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;
  cursor: pointer;
  user-select: none;
  transition: background 0.2s ease;
}

.html5-spec-header:hover {
  background: linear-gradient(135deg, #f1f5f9 0%, #e2e8f0 100%);
}

.html5-spec-header-left {
  display: flex;
  align-items: center;
  flex: 1;
}

.html5-spec-title {
  display: block;
  font-weight: 600;
  font-size: 16px;
  color: #1e293b;
  margin-bottom: 2px;
}

.html5-spec-subtitle {
  display: block;
  font-size: 12px;
  color: #64748b;
  font-weight: 400;
}

.html5-spec-header-right {
  display: flex;
  align-items: center;
  gap: 12px;
}

.html5-spec-link {
  display: flex;
  align-items: center;
  font-size: 13px;
  color: #409EFF;
  text-decoration: none;
  padding: 6px 12px;
  border-radius: 6px;
  transition: all 0.2s ease;
  font-weight: 500;
}

.html5-spec-link:hover {
  background: #ecf5ff;
  color: #66b1ff;
}

.html5-spec-toggle-icon {
  color: #64748b;
  font-size: 16px;
  transition: transform 0.3s ease;
}

.html5-spec-content {
  padding: 20px;
  animation: slideDown 0.3s ease;
}

@keyframes slideDown {
  from {
    opacity: 0;
    transform: translateY(-10px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

.html5-quick-checklist {
  display: flex;
  flex-wrap: wrap;
  gap: 12px;
  padding: 16px;
  background: linear-gradient(135deg, #f0f9ff 0%, #e0f2fe 100%);
  border-radius: 8px;
  margin-bottom: 20px;
  border: 1px solid #bae6fd;
}

.html5-checklist-item {
  display: flex;
  align-items: center;
  gap: 8px;
  font-size: 13px;
  color: #0c4a6e;
  font-weight: 500;
}

.html5-checklist-item code {
  background: rgba(255, 255, 255, 0.8);
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 12px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  color: #0369a1;
}

.html5-requirements-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(280px, 1fr));
  gap: 16px;
}

.html5-requirement-card {
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 10px;
  overflow: hidden;
  transition: all 0.3s ease;
  box-shadow: 0 1px 3px rgba(0, 0, 0, 0.05);
}

.html5-requirement-card:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.1);
}

.html5-card-header {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 14px 16px;
  border-bottom: 1px solid rgba(0, 0, 0, 0.05);
}

.html5-card-title {
  font-weight: 600;
  font-size: 14px;
  color: #1e293b;
}

.html5-card-body {
  padding: 16px;
}

.html5-requirement-item {
  display: flex;
  gap: 12px;
  margin-bottom: 16px;
  align-items: flex-start;
}

.html5-requirement-item:last-child {
  margin-bottom: 0;
}

.html5-requirement-item i {
  font-size: 20px;
  margin-top: 2px;
  flex-shrink: 0;
}

.html5-requirement-item strong {
  display: block;
  font-size: 13px;
  color: #1e293b;
  margin-bottom: 4px;
  font-weight: 600;
}

.html5-requirement-item p {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

.html5-requirement-item code {
  background: #f1f5f9;
  padding: 2px 6px;
  border-radius: 4px;
  font-size: 11px;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  color: #475569;
}

.html5-lean-item {
  display: flex;
  gap: 12px;
  margin-bottom: 14px;
  align-items: flex-start;
}

.html5-lean-item:last-child {
  margin-bottom: 0;
}

.html5-lean-letter {
  width: 32px;
  height: 32px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
  font-weight: 700;
  font-size: 16px;
  flex-shrink: 0;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}

.html5-lean-item strong {
  display: block;
  font-size: 13px;
  color: #1e293b;
  margin-bottom: 4px;
  font-weight: 600;
}

.html5-lean-item p {
  font-size: 12px;
  color: #64748b;
  line-height: 1.5;
  margin: 0;
}

.html5-code-example {
  background: #f8fafc;
  border: 1px solid #e2e8f0;
  border-radius: 8px;
  overflow: hidden;
}

.html5-code-header {
  padding: 10px 12px;
  background: #f1f5f9;
  border-bottom: 1px solid #e2e8f0;
  font-size: 12px;
  color: #475569;
  font-weight: 500;
}

.html5-code-block {
  padding: 14px 12px;
  background: #1e293b;
  color: #e2e8f0;
  font-family: 'Monaco', 'Menlo', 'Ubuntu Mono', monospace;
  font-size: 13px;
  line-height: 1.6;
  overflow-x: auto;
}

.html5-code-block code {
  color: #fbbf24;
  background: transparent;
  padding: 0;
  font-size: 13px;
}

.html5-code-note {
  padding: 10px 12px;
  background: #fef3c7;
  border-top: 1px solid #fde68a;
  font-size: 12px;
  color: #92400e;
  display: flex;
  align-items: center;
}

// RESPONSIVE FILE MOBILE BREAKPOINSTS
@media (max-width: 767.98px) {
  .media-collection-grid {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
  
  .recommended-sizes-grid {
    gap: 6px;
  }
  
  .size-badge {
    font-size: 10px;
    padding: 3px 6px;
  }

  .html5-requirements-grid {
    grid-template-columns: 1fr;
  }

  .html5-spec-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 12px;
  }

  .html5-spec-header-right {
    width: 100%;
    justify-content: space-between;
  }

  .html5-quick-checklist {
    flex-direction: column;
    gap: 8px;
  }
}
</style>

